import { SvgIcon, SvgIconProps } from "@mui/material";

export const ArrowBackIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "24", height: "24", fill: "none" }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path d="M19 12H5M5 12L11 6M5 12L11 18" stroke="#111111" strokeWidth="2" strokeLinecap="round" />
    </SvgIcon>
  );
};

export const FootballMatchIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "64", height: "64", fill: "none" }}
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
    >
      <rect width="64" height="64" rx="32" fill="#F5F6F5" />
      <g clip-path="url(#clip0_34016_40231)">
        <path
          d="M42.956 21.4643C42.9092 21.8134 42.9092 22.1671 42.956 22.5161C42.9742 22.5984 43.0239 22.6703 43.0945 22.7165C43.165 22.7626 43.2508 22.7793 43.3335 22.763C43.4672 22.743 43.5924 22.6849 43.6939 22.5956C43.7955 22.5064 43.8692 22.3897 43.9062 22.2596L44.1191 21.7144C44.1501 21.601 44.1453 21.4808 44.1055 21.3703C44.0656 21.2597 43.9927 21.1641 43.8965 21.0965C43.5561 20.8255 42.9867 21.0804 42.956 21.4643Z"
          fill="#F4A28C"
        />
        <path d="M44.0846 21.8145L44.3201 23.8745L43.1748 23.9229L43.4636 22.4033L44.0846 21.8145Z" fill="#F4A28C" />
        <path
          d="M19.4643 23.9454L30.3306 26.4071L30.1322 27.3315C30.1322 27.3315 24.699 27.1944 20.6387 27.9768C16.5783 28.7591 19.4643 23.9454 19.4643 23.9454Z"
          fill="#008B07"
        />
        <path d="M47.4032 33L46.4573 43.3941H45.62L44.6602 35.3615L41.7344 33H47.4032Z" fill="#F4A28C" />
        <path d="M41.7333 33L40.1582 43.3941H41.1019L44.104 34.1819L41.7333 33Z" fill="#F4A28C" />
        <path d="M47.4032 33V37.369L44.2462 37.1331L44.1051 35.4794L41.7344 33H47.4032Z" fill="#111111" />
        <path d="M44.1046 34.7717L43.6652 37.0938L40.5127 36.8579L41.7339 33L44.1046 34.7717Z" fill="#111111" />
        <path
          d="M45.6452 42.9592C45.6452 42.9592 44.0516 43.4634 44.3269 44H46.6398L46.4987 42.9592H45.6452Z"
          fill="#008B07"
        />
        <path
          d="M40.3526 42.9592C40.3526 42.9592 38.7567 43.4634 39.0319 44H41.3564L41.2153 42.9592H40.3526Z"
          fill="#008B07"
        />
        <path d="M14.7002 33L15.6462 43.3941H16.4834L17.4433 35.3615L20.3691 33H14.7002Z" fill="#F4A28C" />
        <path d="M20.3684 33L21.9458 43.3941H20.9998L18 34.1819L20.3684 33Z" fill="#F4A28C" />
        <path d="M14.7002 33V37.369L17.8596 37.1331L18.0007 35.4794L20.3691 33H14.7002Z" fill="#111111" />
        <path d="M18 34.7717L18.4394 37.0938L21.5896 36.8579L20.3684 33L18 34.7717Z" fill="#111111" />
        <path
          d="M16.4691 42.9592C16.4691 42.9592 18.0627 43.4634 17.7875 44H15.4746L15.6157 42.9592H16.4691Z"
          fill="#008B07"
        />
        <path
          d="M21.752 42.9592C21.752 42.9592 23.3456 43.4634 23.0703 44H20.7598L20.9009 42.9592H21.752Z"
          fill="#008B07"
        />
        <path
          opacity="0.08"
          d="M19.4643 23.9454L30.3306 26.4071L30.1322 27.3315C30.1322 27.3315 24.699 27.1944 20.6387 27.9768C16.5783 28.7591 19.4643 23.9454 19.4643 23.9454Z"
          fill="#111111"
        />
        <path
          d="M42.9233 21.8629L42.741 22.0984C42.731 22.112 42.7244 22.1278 42.7219 22.1444C42.7193 22.1611 42.7209 22.1781 42.7265 22.194C42.7321 22.21 42.7415 22.2243 42.7538 22.2357C42.7662 22.2472 42.7812 22.2554 42.7975 22.2597L43.0379 22.3162L42.9233 21.8629Z"
          fill="#F4A28C"
        />
        <path
          d="M42.7153 23.9454L31.8926 26.6056L32.1829 27.1928C32.1829 27.1928 37.479 27.1928 41.5393 27.9671C45.5997 28.7414 42.7153 23.9454 42.7153 23.9454Z"
          fill="#F4A28C"
        />
        <path
          opacity="0.31"
          d="M43.3863 22.7337C43.53 22.704 43.6618 22.6328 43.7654 22.5288C43.7093 22.8236 43.5432 23.0859 43.3008 23.2628L43.3863 22.7337Z"
          fill="#CE8172"
        />
        <path
          d="M37.8018 27.4701L38.0792 25.0874L41.904 24.1034L42.3412 28.0573C40.8038 28.1762 39.2583 27.9763 37.8018 27.4701Z"
          fill="#008B07"
        />
        <path
          opacity="0.08"
          d="M37.8018 27.4701L38.0792 25.0874L41.904 24.1034L42.3412 28.0573C40.8038 28.1762 39.2583 27.9763 37.8018 27.4701Z"
          fill="#111111"
        />
        <path
          d="M41.9034 24.1035C41.9034 24.1035 46.8139 23.0049 48.5723 23.9905C50.3306 24.9762 47.5 34.4999 47.5 34.4999L41.4582 34.0971C41.4582 34.0971 36.7139 25.0472 41.9034 24.1035Z"
          fill="#008B07"
        />
        <path
          d="M19.2233 21.4643C19.271 21.8133 19.271 22.1672 19.2233 22.5161C19.2051 22.5984 19.1554 22.6703 19.0849 22.7165C19.0143 22.7626 18.9285 22.7793 18.8458 22.763C18.7122 22.7433 18.5871 22.6853 18.4857 22.5959C18.3844 22.5066 18.3111 22.3898 18.2748 22.2596L18.0602 21.7144C18.0292 21.6009 18.034 21.4805 18.0742 21.3699C18.1144 21.2592 18.1878 21.1637 18.2845 21.0965C18.6248 20.8255 19.1895 21.0804 19.2233 21.4643Z"
          fill="#F4A28C"
        />
        <path d="M18.0943 21.8145L17.8604 23.8745L19.0057 23.9229L18.7153 22.4033L18.0943 21.8145Z" fill="#F4A28C" />
        <path
          d="M19.2552 21.8629L19.4423 22.0984C19.4528 22.1118 19.4597 22.1277 19.4625 22.1444C19.4652 22.1612 19.4637 22.1784 19.4581 22.1945C19.4525 22.2105 19.4429 22.2249 19.4303 22.2363C19.4177 22.2477 19.4024 22.2558 19.3859 22.2597L19.1455 22.3162L19.2552 21.8629Z"
          fill="#F4A28C"
        />
        <path
          opacity="0.31"
          d="M18.7922 22.7337C18.6485 22.704 18.5166 22.6328 18.4131 22.5288C18.4695 22.8239 18.6362 23.0863 18.8793 23.2628L18.7922 22.7337Z"
          fill="#CE8172"
        />
        <path
          d="M20.2735 24.1035C20.2735 24.1035 15.363 23.0049 13.6046 23.9905C11.8463 24.9762 15.2984 34.268 15.2984 34.268L20.7203 34.0971C20.7203 34.0971 25.463 25.0472 20.2735 24.1035Z"
          fill="#008B07"
        />
        <path
          opacity="0.08"
          d="M16.0113 24.8522C16.0113 24.8522 17.5632 25.8572 16.7727 28.1527C15.9823 30.4483 15.8548 32.0937 17.718 31.5178C19.5813 30.9419 19.4441 30.9064 19.4441 30.9064L21.3444 31.2L21.5283 32.3131L20.7218 34.0973L16.0113 33.8004L14.0932 33.3165L13.3818 30.9064L14.6853 26.8299L16.0113 24.8522Z"
          fill="#111111"
        />
        <path
          d="M15.0537 23.7019C15.0537 23.7019 12 23.1873 12 27.993C12 32.7986 12.734 37.0767 19.7835 32.7905L19.248 31.9726C19.248 31.9726 15.4506 33.6439 14.6424 32.1759C13.8342 30.7079 17.8139 24.5085 15.0537 23.7019Z"
          fill="#008B07"
        />
        <path
          opacity="0.46"
          d="M15.0537 23.7019C15.0537 23.7019 12 23.1873 12 27.993C12 32.7986 12.734 37.0767 19.7835 32.7905L19.248 31.9726C19.248 31.9726 15.4506 33.6439 14.6424 32.1759C13.8342 30.7079 17.8139 24.5085 15.0537 23.7019Z"
          fill="white"
        />
        <path
          opacity="0.08"
          d="M46.7965 25.0876C46.7965 25.0876 45.6173 26.0233 46.3336 28.0591C47.0498 30.0949 46.3707 33.5439 44.3203 33.9165L47.5 34.5L49 29L46.7965 25.0876Z"
          fill="#111111"
        />
        <path
          d="M19.102 21.4918C19.055 21.5073 19.007 21.5196 18.9584 21.5289C18.8903 21.5444 18.8238 21.5666 18.76 21.5951L18.7084 21.6177C18.6718 21.6337 18.6406 21.6602 18.6188 21.6937C18.5971 21.7272 18.5856 21.7664 18.5858 21.8064C18.5936 21.8836 18.5853 21.9615 18.5613 22.0352C18.5373 22.109 18.4981 22.1769 18.4463 22.2346C18.3945 22.2923 18.3312 22.3386 18.2605 22.3704C18.1898 22.4022 18.1132 22.4189 18.0357 22.4194C18.0357 22.4194 17.5372 21.6757 17.9357 21.1047C18.0523 20.9467 18.2028 20.8167 18.3761 20.7243C18.5495 20.6319 18.7412 20.5794 18.9375 20.5707C19.0497 20.5694 19.1589 20.6079 19.2454 20.6795C19.332 20.751 19.3903 20.851 19.41 20.9616C19.4298 21.0721 19.4097 21.1861 19.3533 21.2832C19.2968 21.3803 19.2078 21.4542 19.102 21.4918Z"
          fill="#111111"
        />
        <path
          d="M18.5765 22.1564C18.5943 22.1339 18.6057 22.1072 18.6097 22.0788C18.6137 22.0505 18.61 22.0216 18.5991 21.9951C18.5636 21.9112 18.4943 21.7983 18.3781 21.8144C18.262 21.8306 18.2378 22.0209 18.32 22.1371C18.3351 22.1568 18.3545 22.1728 18.3767 22.1838C18.399 22.1948 18.4235 22.2005 18.4483 22.2005C18.4731 22.2005 18.4976 22.1948 18.5198 22.1838C18.5421 22.1728 18.5615 22.1568 18.5765 22.1371V22.1564Z"
          fill="#F4A28C"
        />
        <path
          d="M42.6431 20.8158C42.7267 20.9387 42.7818 21.0787 42.8044 21.2255C42.8041 21.2705 42.8146 21.3149 42.8349 21.3551C42.8552 21.3952 42.8849 21.4299 42.9213 21.4563C42.9578 21.4826 43 21.4999 43.0445 21.5066C43.089 21.5133 43.1345 21.5093 43.1771 21.4949C43.661 21.4111 43.4997 22.3225 44.1337 22.2193C44.2295 22.2159 44.3217 22.1817 44.3967 22.1219C44.4716 22.062 44.5253 21.9797 44.5499 21.8869C44.572 21.7907 44.6151 21.7006 44.6762 21.6231C44.7373 21.5455 44.8148 21.4825 44.9032 21.4385C45.037 21.3739 45.1403 21.2433 45.0774 20.9836C44.937 20.3964 44.4821 21.1271 44.3224 20.4996C44.1627 19.8721 43.8965 19.9705 43.7675 20.0834C43.6384 20.1963 43.5062 20.3657 43.3029 20.1592C43.0996 19.9527 42.3592 20.3625 42.6431 20.8158Z"
          fill="#111111"
        />
        <path
          d="M43.605 22.1564C43.5873 22.1339 43.5758 22.1072 43.5719 22.0788C43.5679 22.0505 43.5715 22.0216 43.5824 21.9951C43.6179 21.9112 43.6873 21.7983 43.8018 21.8144C43.9164 21.8306 43.9422 22.0209 43.8615 22.1371C43.8465 22.1568 43.8271 22.1728 43.8048 22.1838C43.7826 22.1948 43.7581 22.2005 43.7333 22.2005C43.7085 22.2005 43.684 22.1948 43.6617 22.1838C43.6395 22.1728 43.6201 22.1568 43.605 22.1371V22.1564Z"
          fill="#F4A28C"
        />
        <path
          d="M30.3019 26.5425L30.7214 26.6683C30.8367 26.7016 30.9408 26.7655 31.0226 26.8533C31.1044 26.9411 31.1609 27.0494 31.186 27.1668C31.2311 27.3862 31.2344 27.6265 31.0618 27.6991C30.723 27.8395 30.1777 27.1216 30.1777 27.1216L30.3019 26.5425Z"
          fill="#F4A28C"
        />
        <path
          d="M32.1222 26.5425L31.7286 26.6602C31.6006 26.6978 31.4858 26.7708 31.3974 26.8706C31.3089 26.9705 31.2504 27.0933 31.2285 27.2248C31.1947 27.4265 31.2059 27.633 31.3624 27.6991C31.7012 27.8395 32.2464 27.1216 32.2464 27.1216L32.1222 26.5425Z"
          fill="#F4A28C"
        />
        <path
          d="M48.099 23.7776C49.1363 23.868 50.451 24.7681 51.348 28.1783L48.2023 29.3076L46.8633 25.3827C46.7984 25.1929 46.7814 24.99 46.814 24.792C46.8466 24.594 46.9277 24.4072 47.05 24.2483C47.1724 24.0893 47.3323 23.9631 47.5153 23.881C47.6984 23.7988 47.8989 23.7633 48.099 23.7776Z"
          fill="#008B07"
        />
        <path
          opacity="0.46"
          d="M48.099 23.7776C49.1363 23.868 50.451 24.7681 51.348 28.1783L48.2023 29.3076L46.8633 25.3827C46.7984 25.1929 46.7814 24.99 46.814 24.792C46.8466 24.594 46.9277 24.4072 47.05 24.2483C47.1724 24.0893 47.3323 23.9631 47.5153 23.881C47.6984 23.7988 47.8989 23.7633 48.099 23.7776Z"
          fill="white"
        />
        <path
          d="M17.4521 23.7792C17.4521 23.7792 17.5231 22.9726 18.4701 23.263C19.417 23.5534 19.4654 23.9454 19.4654 23.9454L17.4521 23.7792Z"
          fill="#008B07"
        />
        <path
          opacity="0.46"
          d="M17.4521 23.7792C17.4521 23.7792 17.5231 22.9726 18.4701 23.263C19.417 23.5534 19.4654 23.9454 19.4654 23.9454L17.4521 23.7792Z"
          fill="white"
        />
        <path
          d="M51.1784 28.1785L51.9075 30.7741C52.0798 31.3887 52.0083 32.0462 51.7077 32.6094C51.4072 33.1726 50.9009 33.5981 50.2944 33.7972L48.0875 34.3489C47.968 34.3778 47.8582 34.4378 47.7692 34.5227C47.6803 34.6077 47.6153 34.7147 47.581 34.8328C47.5133 35.0667 47.3971 35.3168 47.2051 35.3023C46.4098 35.2313 47.168 34.1004 47.168 34.1004L49.3232 32.755C49.5891 32.5888 49.783 32.3288 49.8666 32.0266C49.9502 31.7244 49.9175 31.4018 49.7749 31.1225L48.7473 29.1254L51.1784 28.1785Z"
          fill="#F4A28C"
        />
        <path
          d="M19.3506 32.134C19.3506 32.134 19.8684 31.3484 20.3556 31.7453C20.8428 32.1421 19.6522 32.5938 19.6522 32.5938L19.3506 32.134Z"
          fill="#F4A28C"
        />
        <path
          d="M31 41.3671C31 41.8349 31.139 42.2923 31.3993 42.6814C31.6597 43.0705 32.0298 43.3739 32.4629 43.5533C32.896 43.7326 33.3727 43.7799 33.8327 43.6892C34.2927 43.5984 34.7155 43.3737 35.0475 43.0433C35.3796 42.713 35.6061 42.2919 35.6985 41.8332C35.7908 41.3745 35.7448 40.8988 35.5663 40.4661C35.3879 40.0335 35.0849 39.6633 34.6957 39.4024C34.3065 39.1414 33.8485 39.0014 33.3795 39C33.0675 38.9993 32.7583 39.06 32.4697 39.1786C32.1812 39.2973 31.9189 39.4715 31.6979 39.6913C31.4769 39.9112 31.3015 40.1723 31.1817 40.4599C31.062 40.7474 31.0002 41.0557 31 41.3671Z"
          fill="white"
        />
        <path
          d="M31 41.3671C31.0002 40.8984 31.1399 40.4402 31.4013 40.0507C31.6628 39.6613 32.0343 39.358 32.4687 39.1795C32.9031 39.0009 33.3809 38.955 33.8414 39.0477C34.302 39.1403 34.7246 39.3674 35.0557 39.6999C35.3868 40.0325 35.6115 40.4557 35.7012 40.9158C35.791 41.376 35.7418 41.8523 35.5599 42.2845C35.378 42.7167 35.0715 43.0853 34.6794 43.3435C34.2873 43.6018 33.8272 43.7381 33.3574 43.7351C32.7303 43.732 32.1301 43.4811 31.6882 43.0372C31.2463 42.5933 30.9988 41.9927 31 41.3671ZM34.8385 40.6282C34.8149 40.3361 34.7593 40.0473 34.6727 39.7672C34.6683 39.756 34.6602 39.7466 34.6496 39.7407C34.4226 39.5997 34.1822 39.4811 33.9321 39.3867C33.9196 39.3832 33.9064 39.3832 33.894 39.3867L33.611 39.4752C33.4204 39.5326 33.2387 39.616 33.0709 39.723C33.0645 39.7254 33.0592 39.73 33.0559 39.7361C33.0526 39.7421 33.0517 39.7491 33.0532 39.7557C33.0949 40.0292 33.1357 40.3026 33.1773 40.5751C33.1785 40.5808 33.1809 40.5862 33.1843 40.5909C33.1876 40.5956 33.1919 40.5996 33.1969 40.6026C33.4925 40.7453 33.7863 40.8872 34.0784 41.0282C34.0892 41.0326 34.1013 41.0326 34.1121 41.0282L34.8216 40.6468C34.827 40.6477 34.8323 40.6362 34.8385 40.6282ZM32.1148 41.3184L32.4128 41.3335C32.4237 41.3341 32.4345 41.3306 32.443 41.3238C32.6665 41.0931 32.8888 40.8618 33.1099 40.63C33.1166 40.6225 33.1201 40.6126 33.1197 40.6026C33.0801 40.333 33.0396 40.0631 32.9982 39.7929C32.9929 39.754 32.9929 39.754 32.9512 39.7487C32.7293 39.7155 32.5047 39.7048 32.2807 39.7168C32.2656 39.7177 32.2512 39.7236 32.2399 39.7336C32.0249 39.9323 31.8246 40.1461 31.6403 40.3734C31.6339 40.382 31.6307 40.3927 31.6315 40.4035C31.6448 40.5017 31.659 40.599 31.6732 40.6964C31.7006 40.8936 31.7388 41.0891 31.7876 41.2822C31.7876 41.2954 31.7938 41.3043 31.8115 41.3052C31.9126 41.3078 32.0137 41.3131 32.1148 41.3184ZM34.858 40.699L34.835 40.7114L34.1414 41.0848C34.133 41.0887 34.1259 41.0948 34.1207 41.1024C34.1155 41.1101 34.1126 41.119 34.1121 41.1282C34.0891 41.3052 34.0642 41.4822 34.0403 41.6547C34.0208 41.791 34.0022 41.9281 33.9844 42.0653C33.9836 42.0713 33.9842 42.0775 33.986 42.0833C33.9878 42.0891 33.9909 42.0944 33.9951 42.0989L34.4616 42.5166C34.4657 42.5194 34.4703 42.5213 34.4752 42.5223C34.4801 42.5232 34.4851 42.523 34.4899 42.5219C34.75 42.4361 34.9951 42.3105 35.2163 42.1494C35.2331 42.1377 35.2445 42.1199 35.2482 42.0998C35.2902 41.8992 35.3198 41.6961 35.3369 41.4919C35.339 41.4723 35.336 41.4525 35.3281 41.4344C35.2686 41.3149 35.2119 41.1946 35.1507 41.0804C35.0674 40.943 34.9692 40.8151 34.858 40.699ZM32.0936 41.376L31.7956 41.3627C31.7902 41.363 31.785 41.3644 31.7803 41.3669C31.7756 41.3693 31.7714 41.3727 31.7681 41.3769C31.7388 41.422 31.7104 41.4653 31.6794 41.514C31.5964 41.6746 31.535 41.8454 31.4967 42.0219C31.4955 42.0305 31.4971 42.0391 31.5011 42.0467C31.6005 42.2554 31.7109 42.4586 31.8319 42.6555C31.8391 42.6655 31.8489 42.6731 31.8603 42.6776C31.9703 42.7086 32.0802 42.7431 32.1929 42.7661C32.3568 42.7968 32.5237 42.809 32.6904 42.8024C32.7073 42.8024 32.7082 42.7909 32.7126 42.7803C32.7717 42.6204 32.8288 42.4602 32.8838 42.2998C32.8873 42.2933 32.8891 42.286 32.8891 42.2786C32.8891 42.2711 32.8873 42.2639 32.8838 42.2573L32.4288 41.4087C32.426 41.4024 32.4214 41.3972 32.4155 41.3935C32.4097 41.3899 32.4029 41.3881 32.396 41.3884L32.0936 41.376ZM33.4053 43.3475H33.4177C33.6469 43.3245 33.874 43.284 34.0971 43.2263C34.1072 43.2231 34.1162 43.2169 34.1228 43.2086C34.2614 43.0227 34.364 42.8126 34.4252 42.5891C34.4278 42.5821 34.4279 42.5743 34.4257 42.5672C34.4235 42.56 34.4189 42.5537 34.4128 42.5493C34.2626 42.4166 34.1148 42.2836 33.9693 42.1502C33.9619 42.1429 33.9527 42.1376 33.9425 42.135C33.9324 42.1323 33.9218 42.1324 33.9117 42.1352L32.9796 42.3016C32.9719 42.3022 32.9647 42.3052 32.9588 42.3101C32.9529 42.315 32.9487 42.3216 32.9467 42.329C32.8918 42.4847 32.8368 42.6396 32.78 42.7944C32.776 42.8039 32.7748 42.8143 32.7763 42.8244C32.7779 42.8346 32.7822 42.8441 32.7889 42.852C32.9449 43.0642 33.1528 43.233 33.3929 43.3422C33.3968 43.3444 33.401 43.3461 33.4053 43.3475ZM31.2244 40.53L31.2563 40.5167L31.5481 40.3849C31.5626 40.3777 31.5755 40.3678 31.5862 40.3557C31.7839 40.1143 31.9978 39.8866 32.2266 39.6743C32.2354 39.6656 32.2421 39.655 32.2461 39.6434L32.3233 39.4478L32.3862 39.2885C31.8558 39.5397 31.4409 39.9825 31.2253 40.5274L31.2244 40.53ZM35.5968 40.784L35.5888 40.807C35.5297 40.9875 35.4723 41.168 35.4168 41.3485C35.4072 41.3715 35.4006 41.3956 35.3972 41.4202C35.3793 41.6584 35.3444 41.8949 35.2926 42.1281C35.2862 42.1512 35.2832 42.175 35.2837 42.1989C35.2953 42.2927 35.3094 42.3856 35.3227 42.4794C35.3227 42.5077 35.3307 42.5369 35.3361 42.5723C35.5147 42.2826 35.6262 41.9567 35.6624 41.6184C35.6943 41.3387 35.672 41.0554 35.5968 40.784ZM33.0603 43.6457C33.3409 43.6841 33.6262 43.6706 33.9019 43.6059C34.1753 43.5422 34.434 43.4275 34.6647 43.2679C34.5068 43.2617 34.3489 43.259 34.192 43.2564C34.183 43.257 34.174 43.2584 34.1653 43.2608C33.9372 43.322 33.7048 43.3658 33.47 43.3917C33.4342 43.3917 33.3993 43.4025 33.3698 43.4227C33.2758 43.4935 33.1791 43.5599 33.0833 43.628L33.0603 43.6457ZM31.8727 43.1148C31.8727 43.1042 31.8727 43.0997 31.8727 43.0962C31.8567 42.99 31.8417 42.8847 31.8257 42.7794C31.8237 42.7533 31.8167 42.7278 31.8053 42.7042C31.6758 42.4916 31.5574 42.2724 31.4505 42.0476C31.4453 42.0371 31.4384 42.0276 31.4301 42.0193L31.1144 41.7467L31.0984 41.7361C31.1454 42.0281 31.2487 42.3082 31.4027 42.5608C31.529 42.7686 31.6874 42.9552 31.8718 43.1139L31.8727 43.1148ZM33.6323 39.0815L33.6447 39.0947C33.7272 39.1682 33.8088 39.2425 33.8913 39.3151C33.8994 39.322 33.9087 39.3274 33.9188 39.331C34.1878 39.43 34.4462 39.5554 34.6904 39.7053C34.7082 39.7153 34.7278 39.7219 34.748 39.7248C34.7879 39.7301 34.8287 39.7336 34.8695 39.7372L35.0035 39.7495C34.6371 39.376 34.1528 39.14 33.6323 39.0815Z"
          fill="#111111"
        />
        <path
          d="M34.8384 40.6281C34.8322 40.6361 34.8269 40.6476 34.818 40.652L34.1085 41.0334C34.0977 41.0378 34.0856 41.0378 34.0748 41.0334C33.7791 40.893 33.4853 40.7511 33.1932 40.6078C33.1882 40.6047 33.184 40.6008 33.1806 40.596C33.1773 40.5913 33.1749 40.586 33.1737 40.5803C33.132 40.3078 33.0912 40.0343 33.0495 39.7609C33.048 39.7542 33.049 39.7472 33.0522 39.7412C33.0555 39.7352 33.0608 39.7306 33.0673 39.7282C33.235 39.6212 33.4168 39.5378 33.6074 39.4804L33.8903 39.3919C33.9028 39.3884 33.916 39.3884 33.9284 39.3919C34.1786 39.4863 34.4189 39.6048 34.6459 39.7459C34.6565 39.7517 34.6647 39.7611 34.669 39.7724C34.7564 40.0507 34.8132 40.3376 34.8384 40.6281Z"
          fill="white"
        />
        <path
          d="M32.1153 41.3185C32.0142 41.3131 31.9131 41.3078 31.812 41.3043C31.7942 41.3043 31.7916 41.2946 31.788 41.2813C31.7393 41.0882 31.7011 40.8927 31.6736 40.6955C31.6594 40.5982 31.6452 40.5008 31.6319 40.4026C31.6312 40.3918 31.6343 40.3812 31.6408 40.3725C31.8251 40.1452 32.0254 39.9314 32.2404 39.7327C32.2517 39.7227 32.266 39.7168 32.2812 39.7159C32.5052 39.704 32.7298 39.7146 32.9516 39.7478C32.9933 39.7531 32.9933 39.7531 32.9987 39.792C33.0395 40.0622 33.08 40.3321 33.1202 40.6017C33.1206 40.6118 33.1171 40.6216 33.1104 40.6291C32.8887 40.861 32.6664 41.0922 32.4435 41.3229C32.4349 41.3297 32.4242 41.3332 32.4133 41.3326L32.1153 41.3176V41.3185Z"
          fill="white"
        />
        <path
          d="M34.8574 40.699C34.9685 40.8145 35.0666 40.9418 35.15 41.0786C35.2148 41.1945 35.2715 41.3149 35.3274 41.4325C35.3353 41.4506 35.3384 41.4704 35.3363 41.4901C35.3191 41.6943 35.2895 41.8973 35.2476 42.098C35.2439 42.118 35.2324 42.1358 35.2157 42.1475C34.9944 42.3086 34.7494 42.4343 34.4893 42.5201C34.4845 42.5212 34.4794 42.5213 34.4745 42.5204C34.4696 42.5195 34.465 42.5176 34.4609 42.5148L33.9944 42.0971C33.9903 42.0926 33.9872 42.0873 33.9853 42.0815C33.9835 42.0757 33.983 42.0695 33.9838 42.0635C34.0015 41.9263 34.0201 41.7892 34.0396 41.6529C34.0636 41.4759 34.0884 41.2989 34.1115 41.1264C34.1119 41.1172 34.1149 41.1083 34.12 41.1006C34.1252 41.093 34.1324 41.0869 34.1407 41.083L34.8343 40.7096L34.8574 40.699Z"
          fill="white"
        />
        <path
          d="M32.0934 41.376L32.3967 41.391C32.4036 41.3908 32.4104 41.3926 32.4163 41.3962C32.4221 41.3998 32.4267 41.4051 32.4296 41.4114L32.8845 42.26C32.888 42.2665 32.8899 42.2738 32.8899 42.2812C32.8899 42.2886 32.888 42.2959 32.8845 42.3025C32.8254 42.4629 32.7684 42.6231 32.7134 42.7829C32.7134 42.7936 32.708 42.8051 32.6912 42.8051C32.5245 42.8116 32.3576 42.7995 32.1936 42.7688C32.081 42.7431 31.971 42.7086 31.8611 42.6803C31.8497 42.6758 31.8398 42.6681 31.8327 42.6582C31.7117 42.4612 31.6012 42.258 31.5019 42.0494C31.4979 42.0418 31.4963 42.0331 31.4974 42.0246C31.5357 41.848 31.5972 41.6773 31.6801 41.5167C31.7067 41.4698 31.7351 41.4282 31.7688 41.3795C31.7722 41.3754 31.7763 41.372 31.7811 41.3695C31.7858 41.3671 31.791 41.3657 31.7963 41.3654L32.0943 41.3786L32.0934 41.376Z"
          fill="white"
        />
        <path
          d="M33.4056 43.3475C33.4001 43.3464 33.3947 43.3446 33.3896 43.3422C33.1496 43.233 32.9417 43.0642 32.7857 42.852C32.779 42.8441 32.7747 42.8346 32.7731 42.8244C32.7715 42.8143 32.7728 42.8039 32.7768 42.7944C32.8336 42.6396 32.8885 42.4847 32.9435 42.329C32.9455 42.3216 32.9497 42.315 32.9556 42.3101C32.9615 42.3052 32.9687 42.3022 32.9763 42.3016L33.912 42.1352C33.9221 42.1324 33.9328 42.1323 33.9429 42.135C33.953 42.1376 33.9622 42.1429 33.9697 42.1502C34.1181 42.2836 34.2659 42.4166 34.4131 42.5493C34.4193 42.5537 34.4238 42.56 34.426 42.5671C34.4283 42.5743 34.4281 42.5821 34.4255 42.5891C34.3643 42.8126 34.2617 43.0227 34.1231 43.2086C34.1165 43.2169 34.1076 43.2231 34.0974 43.2263C33.8744 43.2839 33.6473 43.3245 33.418 43.3475H33.4056Z"
          fill="white"
        />
        <path
          d="M31.2236 40.5299C31.4392 39.985 31.8542 39.5422 32.3846 39.291L32.3216 39.4503L32.2445 39.6459C32.2404 39.6575 32.2337 39.6681 32.2249 39.6768C31.9965 39.8891 31.7828 40.1168 31.5855 40.3582C31.5748 40.3703 31.5618 40.3802 31.5474 40.3874L31.2556 40.5193L31.2236 40.5299Z"
          fill="white"
        />
        <path
          d="M35.5973 40.7839C35.6722 41.0545 35.6945 41.3368 35.6629 41.6157C35.6267 41.954 35.5152 42.2799 35.3366 42.5697C35.3312 42.5343 35.3268 42.5051 35.3233 42.4767C35.31 42.3829 35.2958 42.29 35.2842 42.1962C35.2837 42.1723 35.2867 42.1485 35.2931 42.1254C35.3449 41.8923 35.3799 41.6557 35.3978 41.4175C35.4011 41.3929 35.4077 41.3688 35.4173 41.3458C35.4764 41.1653 35.5337 40.9848 35.5893 40.8043L35.5973 40.7839Z"
          fill="white"
        />
        <path
          d="M33.0605 43.6457L33.0836 43.628C33.1794 43.5599 33.2761 43.4935 33.3701 43.4227C33.3996 43.4025 33.4345 43.3917 33.4703 43.3917C33.7051 43.3658 33.9375 43.322 34.1656 43.2608C34.1743 43.2584 34.1832 43.257 34.1922 43.2563C34.3492 43.2563 34.5071 43.2617 34.6649 43.2679C34.4343 43.4275 34.1755 43.5422 33.9022 43.6059C33.6265 43.6706 33.3412 43.6841 33.0605 43.6457Z"
          fill="white"
        />
        <path
          d="M31.8709 43.1139C31.6854 42.9551 31.5261 42.7682 31.399 42.5599C31.2455 42.3075 31.1425 42.0277 31.0957 41.7361L31.1117 41.7467L31.4274 42.0184C31.4357 42.0267 31.4426 42.0362 31.4478 42.0467C31.5546 42.2715 31.6731 42.4906 31.8026 42.7033C31.814 42.7269 31.8209 42.7524 31.823 42.7785C31.8389 42.8838 31.854 42.9891 31.87 43.0953C31.8709 43.0988 31.8709 43.1032 31.8709 43.1139Z"
          fill="white"
        />
        <path
          d="M33.6318 39.0814C34.1523 39.14 34.6367 39.376 35.003 39.7495L34.8691 39.7371C34.8283 39.7371 34.7875 39.73 34.7476 39.7247C34.7273 39.7219 34.7077 39.7153 34.6899 39.7053C34.4457 39.5554 34.1873 39.43 33.9183 39.331C33.9083 39.3273 33.8989 39.322 33.8908 39.315C33.8083 39.2425 33.7267 39.1681 33.6443 39.0947L33.6318 39.0814Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_34016_40231">
          <rect width="40" height="40" fill="white" transform="translate(12 12)" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export const TrainingIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "64", height: "64", fill: "none" }}
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
    >
      <rect width="64" height="64" rx="32" fill="#F5F6F5" />
      <path
        d="M37.6196 46.3268L37.0029 45.8688L39.6972 42.2437V35.9996H40.466V42.4973L37.6196 46.3268Z"
        fill="#CFCFCF"
      />
      <path d="M40.2386 41.9297L39.6152 42.3798L42.465 46.3268L43.0884 45.8767L40.2386 41.9297Z" fill="#CFCFCF" />
      <path d="M48.7098 17.4473H31.4531V36.2302H48.7098V17.4473Z" fill="#CFCFCF" />
      <path d="M48.7098 33.4689H31.4531V36.2302H48.7098V33.4689Z" fill="#CFCFCF" />
      <path
        opacity="0.08"
        d="M38.1283 21.5238C38.1283 21.5238 39.3732 21.0772 39.2276 22.8227C39.082 24.5682 38.8775 29.0995 31.5391 30.8875V27.6763L34.5768 26.7766L37.0584 25.1702L37.5492 22.5266L38.1283 21.5238Z"
        fill="#111111"
      />
      <path
        d="M27.4961 21.3195C28.9024 22.0296 30.1003 23.0927 30.9723 24.4048C32.4789 26.6328 36.4115 25.8918 37.133 22.4712C37.133 22.4712 37.4274 20.8664 37.9509 20.9302C38.4744 20.994 37.9509 22.1424 37.9509 22.1424C37.9509 22.1424 38.6723 22.1751 38.6052 22.7329C38.5382 23.2907 37.6548 23.8142 37.6548 23.8142C37.6548 23.8142 36.1138 30.6309 28.6101 26.5019L27.4961 21.3195Z"
        fill="#F4A28C"
      />
      <path
        d="M19.0983 45.2178C19.0983 45.2178 18.8824 45.8181 18.3393 45.8721C17.7962 45.9261 17.6539 46.4479 18.143 46.587C18.6321 46.726 19.8884 46.0962 19.8884 46.0962L19.8541 45.3127L19.0983 45.2178Z"
        fill="#008B07"
      />
      <path
        d="M26.5564 45.2178C26.5564 45.2178 26.7723 45.8181 27.3138 45.8721C27.8553 45.9261 27.9992 46.4479 27.5118 46.587C27.0243 46.726 25.7646 46.0962 25.7646 46.0962L25.8006 45.3127L26.5564 45.2178Z"
        fill="#008B07"
      />
      <path
        d="M24.0483 17.6109C24.2158 18.0304 24.3259 18.4706 24.3754 18.9196C24.3776 18.9733 24.3691 19.0269 24.3504 19.0772C24.3317 19.1276 24.3032 19.1738 24.2666 19.213C24.2299 19.2523 24.1858 19.2839 24.1368 19.306C24.0878 19.328 24.0349 19.3402 23.9812 19.3416C23.8087 19.3585 23.6349 19.325 23.481 19.2452C23.3272 19.1653 23.1997 19.0426 23.1142 18.8918L22.6758 18.2833C22.6018 18.1516 22.5704 18.0002 22.5859 17.8499C22.6014 17.6996 22.6631 17.5578 22.7625 17.4441C23.1044 16.9991 23.8912 17.1414 24.0483 17.6109Z"
        fill="#F4A28C"
      />
      <path d="M22.8662 18.437L22.9006 21.0969L24.3663 20.9742L23.7529 19.0881L22.8662 18.437Z" fill="#F4A28C" />
      <path
        d="M24.0631 17.6192C24.043 17.4988 23.9935 17.3852 23.9189 17.2885C23.8444 17.1918 23.7471 17.1151 23.6357 17.0651C23.5244 17.015 23.4023 16.9933 23.2806 17.0018C23.1588 17.0103 23.041 17.0487 22.9376 17.1137C22.7959 17.1762 22.6689 17.2675 22.5646 17.382C22.4835 17.5014 22.4486 17.6462 22.4665 17.7893C22.4923 18.1386 22.6048 18.4759 22.7937 18.7709C22.8754 18.9001 22.9442 18.9786 23.0947 18.8952C23.2184 18.8235 23.3089 18.706 23.3466 18.568C23.3979 18.4056 23.3838 18.2295 23.3073 18.0773L23.7032 17.8826L23.9011 17.7844C23.9355 17.7664 24.0238 17.7435 24.0467 17.7125C24.063 17.6843 24.0688 17.6513 24.0631 17.6192Z"
        fill="#111111"
      />
      <path
        d="M23.4185 18.5155C23.4185 18.5155 23.3236 18.2177 23.106 18.3077C22.8885 18.3977 23.021 18.8279 23.3383 18.7788L23.4185 18.5155Z"
        fill="#F4A28C"
      />
      <path
        d="M24.2119 18.0967L24.5162 18.3322C24.5339 18.3454 24.5479 18.3629 24.5569 18.3831C24.5659 18.4032 24.5696 18.4254 24.5676 18.4473C24.5656 18.4693 24.5581 18.4904 24.5456 18.5086C24.5332 18.5269 24.5163 18.5416 24.4966 18.5514L24.2152 18.6954L24.2119 18.0967Z"
        fill="#F4A28C"
      />
      <path
        opacity="0.31"
        d="M23.8288 19.3337C23.8288 19.3337 23.6407 19.3517 23.2383 19.1439C23.2383 19.1439 23.3283 19.6674 24.0137 19.8866L23.8288 19.3337Z"
        fill="#CE8172"
      />
      <path
        d="M25.6673 20.84C23.2514 20.8833 20.8668 21.3932 18.6445 22.3417C18.3046 22.486 17.9977 22.6983 17.7428 22.9656C17.4879 23.2328 17.2903 23.5494 17.1623 23.8958C17.0342 24.2422 16.9783 24.6111 16.998 24.9799C17.0177 25.3487 17.1127 25.7096 17.2769 26.0404L21.0983 33.6618L28.1832 33.2431C28.1832 33.2431 29.4723 28.9587 29.2138 24.1133C29.1603 23.2151 28.7611 22.3725 28.0999 21.7623C27.4387 21.152 26.5669 20.8215 25.6673 20.84Z"
        fill="#008B07"
      />
      <path
        opacity="0.08"
        d="M20.513 23.3545C20.513 23.3545 22.1849 24.5896 21.861 26.7898C21.5371 28.99 21.2067 30.7158 23.24 30.1989C25.2734 29.682 26.376 24.9527 26.376 24.9527L28.7496 25.0116L28.339 30.2938L26.9616 30.3887C26.636 30.4109 26.3268 30.5395 26.0815 30.7547C25.8362 30.9699 25.6683 31.2597 25.6038 31.5796L25.2341 33.4216L21.0987 33.6653L20.513 32.7967L17.9317 30.001L17.6045 25.5498L20.513 23.3545Z"
        fill="#111111"
      />
      <path d="M23.3171 29.5587L27.9082 29.8708L28.3357 23.584L23.7446 23.2719L23.3171 29.5587Z" fill="white" />
      <path
        d="M20.1813 38.7251L19.1621 45.2358L19.8557 45.3062L22.6939 38.9967C22.7332 38.905 22.7741 38.8151 22.815 38.7251H20.1813Z"
        fill="#F4A28C"
      />
      <path
        d="M25.3008 38.7251C25.8079 41.8332 25.7915 45.3062 25.7915 45.3062L26.6013 45.3438L27.6515 38.7496L25.3008 38.7251Z"
        fill="#F4A28C"
      />
      <path
        d="M22.3084 39.914L22.6928 38.9963C23.1567 37.8912 23.7983 36.8695 24.592 35.9716C25.0353 37.0791 25.3036 38.5088 25.4639 39.914H27.5824L28.186 33.2495L21.1011 33.6683L19.9658 39.914H22.3084Z"
        fill="#111111"
      />
      <path
        opacity="0.08"
        d="M28.1428 26.4561C28.1428 26.4561 26.5659 29.363 23.389 28.5418L23.3203 29.5593L27.9105 29.8717L28.1428 26.4561Z"
        fill="#111111"
      />
      <path
        d="M25.8269 28.1673C25.0351 27.8646 24.191 28.8543 24.191 28.8543C24.191 28.8543 22.0202 30.6947 20.0425 30.7209C18.5702 30.7405 20.7705 26.9322 20.6707 24.0367C20.6603 23.6814 20.5404 23.3379 20.3275 23.0533C20.1145 22.7687 19.8188 22.5567 19.4809 22.4464C19.1429 22.3362 18.7792 22.333 18.4393 22.4372C18.0995 22.5415 17.8001 22.7482 17.5822 23.029C16.7642 24.0645 16.0216 25.7953 16.0837 28.6384C16.2146 34.7042 19.7759 36.327 25.2723 29.6935C25.2723 29.6935 26.6203 28.4715 25.8269 28.1673Z"
        fill="#F4A28C"
      />
      <path
        d="M24.9181 22.4055C24.9111 22.3372 24.8845 22.2723 24.8413 22.2188C24.7982 22.1652 24.7404 22.1254 24.6751 22.1041C24.6098 22.0827 24.5396 22.0808 24.4732 22.0986C24.4068 22.1164 24.347 22.153 24.301 22.2041C24.2551 22.2552 24.2249 22.3186 24.2143 22.3865C24.2036 22.4544 24.2129 22.5239 24.241 22.5867C24.2691 22.6494 24.3148 22.7026 24.3725 22.7399C24.4303 22.7771 24.4976 22.7968 24.5664 22.7965V23.109H24.9214V22.4055H24.9181Z"
        fill="#111111"
      />
      <path
        d="M24.7601 20.8497C24.7192 20.7434 24.5507 20.7892 24.5965 20.8956C24.7002 21.169 24.7235 21.4665 24.6636 21.7527C24.6392 21.8967 24.587 22.0345 24.5098 22.1584C24.4231 22.2779 24.2432 22.2239 24.1254 22.1862C23.8733 22.0904 23.6454 21.9401 23.458 21.7462C23.2301 21.5587 23.0402 21.3294 22.8985 21.0706C22.8511 20.9675 22.6989 21.0575 22.7464 21.1589C22.8713 21.3972 23.0393 21.6102 23.242 21.7871C23.4129 21.9672 23.6078 22.123 23.8211 22.25C24.0109 22.3531 24.3004 22.4709 24.5114 22.3727C24.611 22.3156 24.6856 22.2235 24.7208 22.1143C24.7755 21.9919 24.8151 21.8634 24.8386 21.7315C24.8904 21.4358 24.8633 21.1316 24.7601 20.8497Z"
        fill="#111111"
      />
      <path d="M41.9466 18.6953H38.2168V20.3148H41.9466V18.6953Z" fill="white" />
      <path
        d="M44.3666 27.0729C44.7632 27.0729 45.0848 26.7514 45.0848 26.3547C45.0848 25.9581 44.7632 25.6366 44.3666 25.6366C43.97 25.6366 43.6484 25.9581 43.6484 26.3547C43.6484 26.7514 43.97 27.0729 44.3666 27.0729Z"
        fill="white"
      />
      <path
        d="M38.8636 29.5378C39.2603 29.5378 39.5818 29.2163 39.5818 28.8197C39.5818 28.4231 39.2603 28.1016 38.8636 28.1016C38.467 28.1016 38.1455 28.4231 38.1455 28.8197C38.1455 29.2163 38.467 29.5378 38.8636 29.5378Z"
        fill="white"
      />
      <path
        d="M43.3812 31.1377C43.7779 31.1377 44.0994 30.8162 44.0994 30.4196C44.0994 30.0229 43.7779 29.7014 43.3812 29.7014C42.9846 29.7014 42.6631 30.0229 42.6631 30.4196C42.6631 30.8162 42.9846 31.1377 43.3812 31.1377Z"
        fill="white"
      />
      <path
        d="M43.2587 24.0628C43.4027 23.9221 43.5499 23.7864 43.7021 23.6538C43.735 23.6204 43.7534 23.5753 43.7531 23.5284C43.7528 23.4814 43.7338 23.4365 43.7004 23.4036C43.667 23.3706 43.6219 23.3522 43.5749 23.3525C43.528 23.3528 43.4831 23.3718 43.4501 23.4052C43.298 23.5377 43.1508 23.6751 43.0068 23.8142C42.8612 23.6751 42.714 23.5377 42.5619 23.4052C42.5289 23.3722 42.4842 23.3537 42.4375 23.3537C42.3909 23.3537 42.3462 23.3722 42.3132 23.4052C42.2802 23.4382 42.2617 23.4829 42.2617 23.5295C42.2617 23.5762 42.2802 23.6209 42.3132 23.6538C42.4653 23.7864 42.6126 23.9221 42.7565 24.0628C42.6044 24.2264 42.4555 24.3769 42.3116 24.5405C42.28 24.5742 42.2623 24.6186 42.2623 24.6648C42.2623 24.711 42.28 24.7555 42.3116 24.7891C42.3451 24.8216 42.39 24.8398 42.4367 24.8398C42.4834 24.8398 42.5283 24.8216 42.5619 24.7891C42.7042 24.6255 42.853 24.462 43.0068 24.3098C43.159 24.4734 43.3078 24.6255 43.4518 24.7891C43.4849 24.8219 43.5295 24.8403 43.5761 24.8403C43.6227 24.8403 43.6673 24.8219 43.7004 24.7891C43.7324 24.7556 43.7503 24.7111 43.7503 24.6648C43.7503 24.6185 43.7324 24.574 43.7004 24.5405C43.5597 24.3769 43.4109 24.2182 43.2587 24.0628Z"
        fill="white"
      />
      <path
        d="M40.4469 21.439C40.5909 21.2983 40.7381 21.1609 40.8902 21.0284C40.923 20.9953 40.9414 20.9506 40.9414 20.904C40.9414 20.8575 40.923 20.8128 40.8902 20.7797C40.8567 20.7477 40.8122 20.7299 40.7659 20.7299C40.7196 20.7299 40.675 20.7477 40.6416 20.7797C40.4894 20.9122 40.3422 21.0496 40.1966 21.1903C40.0526 21.0496 39.9054 20.9122 39.7533 20.7797C39.7198 20.7477 39.6753 20.7299 39.6289 20.7299C39.5826 20.7299 39.5381 20.7477 39.5046 20.7797C39.4719 20.8128 39.4535 20.8575 39.4535 20.904C39.4535 20.9506 39.4719 20.9953 39.5046 21.0284C39.6568 21.1609 39.8023 21.2983 39.9479 21.439C39.7958 21.5944 39.6469 21.753 39.503 21.9166C39.471 21.9501 39.4531 21.9946 39.4531 22.041C39.4531 22.0873 39.471 22.1318 39.503 22.1653C39.5361 22.198 39.5807 22.2164 39.6273 22.2164C39.6739 22.2164 39.7186 22.198 39.7516 22.1653C39.8956 22.0017 40.0445 21.8381 40.1966 21.686C40.3487 21.8496 40.4992 22.0017 40.6416 22.1653C40.6579 22.1816 40.6773 22.1946 40.6986 22.2034C40.7199 22.2122 40.7428 22.2168 40.7659 22.2168C40.789 22.2168 40.8118 22.2122 40.8332 22.2034C40.8545 22.1946 40.8739 22.1816 40.8902 22.1653C40.9065 22.149 40.9195 22.1296 40.9283 22.1082C40.9372 22.0869 40.9417 22.064 40.9417 22.041C40.9417 22.0179 40.9372 21.995 40.9283 21.9737C40.9195 21.9523 40.9065 21.933 40.8902 21.9166C40.7479 21.753 40.599 21.5944 40.4469 21.439Z"
        fill="white"
      />
      <path
        d="M40.0654 26.3201C40.2093 26.1794 40.3565 26.042 40.507 25.9095C40.5235 25.8932 40.5365 25.8738 40.5454 25.8525C40.5543 25.8311 40.5589 25.8083 40.5589 25.7851C40.5589 25.762 40.5543 25.7391 40.5454 25.7178C40.5365 25.6965 40.5235 25.6771 40.507 25.6608C40.4736 25.6288 40.429 25.611 40.3827 25.611C40.3364 25.611 40.2919 25.6288 40.2584 25.6608C40.1079 25.7933 39.9607 25.9307 39.8151 26.0714C39.6695 25.9307 39.5223 25.7933 39.3718 25.6608C39.3383 25.6288 39.2937 25.611 39.2474 25.611C39.2011 25.611 39.1566 25.6288 39.1231 25.6608C39.1067 25.6771 39.0937 25.6965 39.0848 25.7178C39.0759 25.7391 39.0713 25.762 39.0713 25.7851C39.0713 25.8083 39.0759 25.8311 39.0848 25.8525C39.0937 25.8738 39.1067 25.8932 39.1231 25.9095C39.2736 26.042 39.4208 26.1794 39.5664 26.3201C39.4143 26.4837 39.2654 26.6341 39.1215 26.7977C39.0895 26.8312 39.0716 26.8757 39.0716 26.9221C39.0716 26.9684 39.0895 27.0129 39.1215 27.0464C39.1546 27.0792 39.1992 27.0975 39.2458 27.0975C39.2924 27.0975 39.337 27.0792 39.3701 27.0464C39.5141 26.8828 39.6629 26.7192 39.8151 26.5671C39.9672 26.7307 40.1161 26.8828 40.26 27.0464C40.2931 27.0792 40.3378 27.0975 40.3843 27.0975C40.4309 27.0975 40.4756 27.0792 40.5087 27.0464C40.5407 27.0129 40.5585 26.9684 40.5585 26.9221C40.5585 26.8757 40.5407 26.8312 40.5087 26.7977C40.3647 26.6341 40.2159 26.4755 40.0654 26.3201Z"
        fill="white"
      />
      <path
        d="M47.3454 26.9061L46.9136 26.3957C46.9025 26.3759 46.8875 26.3586 46.8694 26.345V26.3351C46.8362 26.3025 46.7916 26.2843 46.7451 26.2844C46.6987 26.2848 46.6542 26.303 46.6207 26.3351C46.5916 26.3663 46.5748 26.407 46.5733 26.4496C46.4751 26.5746 46.3697 26.6936 46.2576 26.8063C46.2257 26.8194 46.1988 26.8423 46.1807 26.8717L46.1512 26.924C46.1313 26.961 46.1252 27.0038 46.1339 27.0448C46.1427 27.0858 46.1657 27.1224 46.199 27.148C46.2323 27.1736 46.2735 27.1865 46.3154 27.1844C46.3573 27.1824 46.3971 27.1654 46.4277 27.1367C46.4915 27.0745 46.5504 27.0091 46.6093 26.9437C46.6881 28.436 46.2322 29.9075 45.3235 31.0938C45.1861 31.2705 45.4331 31.5208 45.5721 31.3425C46.5363 30.1012 47.029 28.5582 46.9626 26.9878L47.1033 27.1514C47.1363 27.1845 47.181 27.2033 47.2277 27.2038C47.2508 27.2037 47.2737 27.199 47.2951 27.1901C47.3164 27.1811 47.3358 27.1679 47.352 27.1514C47.3822 27.1173 47.3983 27.073 47.397 27.0275C47.3958 26.9819 47.3774 26.9385 47.3454 26.9061Z"
        fill="white"
      />
      <path
        d="M37.4606 31.8363C37.1481 31.7856 36.9535 31.5271 36.7833 31.2834C36.5806 30.9913 36.398 30.6858 36.237 30.3689C35.9649 29.8251 35.7589 29.2506 35.6235 28.6578C35.7527 28.738 35.8853 28.8214 36.0227 28.8836C36.0632 28.9059 36.1109 28.9118 36.1557 28.8999C36.2005 28.888 36.239 28.8593 36.2631 28.8198C36.2864 28.7794 36.2927 28.7314 36.2807 28.6864C36.2688 28.6413 36.2395 28.6029 36.1993 28.5793C35.9652 28.4621 35.7404 28.327 35.527 28.1752C35.4884 28.1531 35.4428 28.1464 35.3995 28.1564C35.3561 28.1664 35.3181 28.1924 35.2931 28.2292C35.2715 28.2434 35.2535 28.2624 35.2407 28.2848L34.853 29.0226C34.8388 29.0426 34.8289 29.0654 34.8239 29.0895C34.819 29.1135 34.8191 29.1384 34.8243 29.1624C34.8295 29.1864 34.8397 29.2091 34.8541 29.229C34.8686 29.2488 34.887 29.2655 34.9083 29.2778C34.9295 29.2901 34.9531 29.2979 34.9775 29.3006C35.002 29.3033 35.0267 29.3009 35.0501 29.2935C35.0736 29.2861 35.0952 29.2739 35.1136 29.2577C35.1321 29.2415 35.147 29.2216 35.1573 29.1993L35.3209 28.8966C35.4757 29.508 35.7025 30.0989 35.9965 30.6568C36.1714 30.9941 36.3738 31.3164 36.6018 31.6203C36.7981 31.8788 37.0385 32.1111 37.3706 32.1733C37.5882 32.2109 37.6831 31.8723 37.4606 31.8363Z"
        fill="white"
      />
      <path
        d="M36.3995 22.2241C36.3454 21.9279 36.224 21.648 36.0445 21.4062C36.0293 21.3615 35.9988 21.3235 35.9584 21.299C35.9181 21.2745 35.8703 21.265 35.8236 21.2721C35.5206 21.3251 35.2251 21.4146 34.9435 21.5387C34.9062 21.5638 34.8799 21.6022 34.8699 21.646C34.8599 21.6899 34.867 21.7359 34.8897 21.7746C34.9124 21.8134 34.9491 21.8421 34.9922 21.8548C35.0354 21.8675 35.0817 21.8633 35.1219 21.843C35.2418 21.7916 35.3647 21.7473 35.4899 21.7105C35.3263 21.9788 35.1628 22.2552 35.0286 22.5382C34.829 22.9456 34.6147 23.3758 34.7014 23.8469C34.7407 24.0694 35.0793 23.9761 35.0417 23.7537C34.973 23.3627 35.2266 22.9357 35.3983 22.6086C35.5436 22.328 35.703 22.055 35.876 21.7906C35.9061 21.8437 35.9334 21.8983 35.9578 21.9542C35.9602 21.9604 35.9629 21.9664 35.966 21.9722L35.9856 22.0229L36.0199 22.126C36.0409 22.1948 36.0578 22.2647 36.0707 22.3354C36.0767 22.3577 36.0871 22.3785 36.1013 22.3968C36.1154 22.415 36.133 22.4303 36.1531 22.4417C36.1732 22.4531 36.1953 22.4604 36.2182 22.4632C36.2411 22.466 36.2644 22.4643 36.2866 22.4581C36.3098 22.4508 36.3313 22.4388 36.3497 22.4229C36.3681 22.4069 36.383 22.3874 36.3936 22.3655C36.4041 22.3436 36.4101 22.3197 36.4111 22.2954C36.4121 22.2711 36.4082 22.2469 36.3995 22.2241Z"
        fill="white"
      />
      <path
        d="M44.19 21.7757L44.7119 21.7953C44.7576 21.7949 44.8014 21.7768 44.834 21.7447C44.8667 21.7127 44.8856 21.6693 44.8869 21.6235C44.8861 21.5774 44.8674 21.5333 44.8347 21.5007C44.8021 21.4681 44.758 21.4493 44.7119 21.4485L43.7304 21.4125C43.6998 21.4043 43.6677 21.4043 43.6371 21.4125H43.6142C43.5676 21.4129 43.5231 21.4318 43.4903 21.4648C43.4576 21.4979 43.4392 21.5426 43.4392 21.5892C43.44 21.6181 43.4484 21.6464 43.4637 21.671C43.3752 21.9159 43.3483 22.1788 43.3852 22.4366C43.4146 22.659 43.7549 22.5642 43.7238 22.3417C43.7038 22.1819 43.7178 22.0197 43.7647 21.8657C44.1868 22.22 44.5227 22.6657 44.7472 23.169C44.9717 23.6724 45.0787 24.2201 45.0603 24.7709C45.0505 24.9967 45.4022 24.9967 45.412 24.7709C45.4292 24.214 45.3293 23.6596 45.1188 23.1437C44.9083 22.6277 44.5919 22.1617 44.19 21.7757Z"
        fill="white"
      />
    </SvgIcon>
  );
};

export const TryoutIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "64", height: "64", fill: "none" }}
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
    >
      <rect width="64" height="64" rx="32" fill="#F5F6F5" />
      <path
        d="M32.0865 15.0768C31.9712 15.8588 31.9712 16.6513 32.0865 17.4333C32.1313 17.6177 32.2537 17.7788 32.4274 17.8821C32.6011 17.9855 32.8123 18.0229 33.0159 17.9863C33.3452 17.9416 33.6533 17.8114 33.9034 17.6114C34.1535 17.4114 34.3349 17.1501 34.426 16.8586L34.9503 15.637C35.0266 15.383 35.0148 15.1137 34.9167 14.866C34.8186 14.6182 34.6389 14.404 34.4021 14.2527C33.564 13.6455 32.1619 14.2165 32.0865 15.0768Z"
        fill="#F4A28C"
      />
      <path d="M34.5555 15.8977L34.9316 19.1875L33.1025 19.2648L33.5637 16.838L34.5555 15.8977Z" fill="#F4A28C" />
      <path d="M39.8558 33.7606L38.3451 50.3597H37.008L35.4751 37.5318L30.8027 33.7606H39.8558Z" fill="#F4A28C" />
      <path d="M30.8005 33.7606L28.2852 50.3597H29.7921L34.5864 35.6481L30.8005 33.7606Z" fill="#F4A28C" />
      <path d="M39.8558 33.7606V40.7379L34.814 40.3611L34.5887 37.7202L30.8027 33.7606H39.8558Z" fill="#111111" />
      <path d="M34.5887 36.5899L33.8869 40.2983L28.8525 39.9216L30.8028 33.7606L34.5887 36.5899Z" fill="#111111" />
      <path
        d="M37.048 49.6652C37.048 49.6652 34.5031 50.4704 34.9426 51.3273H38.6362L38.4109 49.6652H37.048Z"
        fill="#008B07"
      />
      <path
        d="M28.5956 49.6652C28.5956 49.6652 26.047 50.4704 26.4865 51.3273H30.1986L29.9733 49.6652H28.5956Z"
        fill="#008B07"
      />
      <path
        d="M32.7663 16.0206L31.8444 16.281C31.7932 16.2965 31.7552 16.3213 31.7338 16.3532C31.7123 16.385 31.7079 16.423 31.7211 16.4638C31.7344 16.5046 31.7647 16.5469 31.8095 16.5871C31.8543 16.6273 31.9123 16.6641 31.9782 16.6943L32.9561 17.1249L32.7663 16.0206Z"
        fill="#F4A28C"
      />
      <path
        d="M30.0495 20.0405L19.7855 34.581L20.7505 34.9849C20.7505 34.9849 27.1362 29.4392 32.8428 26.121C38.5493 22.8029 30.0495 20.0405 30.0495 20.0405Z"
        fill="#F4A28C"
      />
      <path
        opacity="0.31"
        d="M33.4393 17.3649C33.6688 17.3175 33.8793 17.2038 34.0447 17.0377C33.9551 17.5084 33.6898 17.9274 33.3027 18.2099L33.4393 17.3649Z"
        fill="#CE8172"
      />
      <path
        d="M27.8154 29.4363L25.655 26.2729L29.2363 21.0813L33.9037 25.3909C32.1745 27.1442 30.1018 28.5214 27.8154 29.4363Z"
        fill="#008B07"
      />
      <path
        opacity="0.08"
        d="M27.8154 29.4363L25.655 26.2729L29.2363 21.0813L33.9037 25.3909C32.1745 27.1442 30.1018 28.5214 27.8154 29.4363Z"
        fill="#111111"
      />
      <path
        d="M31.0725 19.5531C31.0725 19.5531 38.9145 17.7987 41.7225 19.3727C44.5306 20.9468 40.0101 36.1559 40.0101 36.1559L30.3615 35.5126C30.3615 35.5126 22.7849 21.0602 31.0725 19.5531Z"
        fill="#008B07"
      />
      <path
        opacity="0.08"
        d="M38.8851 21.1248C38.8851 21.1248 37.0019 22.6189 38.1458 25.8701C39.2896 29.1213 38.205 34.6292 34.9307 35.2243L40.0085 36.156L42.404 27.3727L38.8851 21.1248Z"
        fill="#111111"
      />
      <path
        d="M32.2536 14.3028C32.3871 14.499 32.4751 14.7226 32.5112 14.9571C32.5107 15.029 32.5274 15.0999 32.5599 15.164C32.5924 15.2281 32.6397 15.2835 32.6979 15.3256C32.7561 15.3677 32.8236 15.3953 32.8946 15.406C32.9657 15.4168 33.0382 15.4104 33.1063 15.3874C33.8792 15.2534 33.6216 16.709 34.634 16.5441C34.7871 16.5387 34.9343 16.4842 35.054 16.3886C35.1737 16.293 35.2595 16.1615 35.2986 16.0134C35.3339 15.8597 35.4028 15.7158 35.5003 15.592C35.5979 15.4681 35.7217 15.3675 35.8628 15.2972C36.0766 15.1942 36.2415 14.9855 36.141 14.5707C35.9169 13.633 35.1904 14.8 34.9354 13.7979C34.6804 12.7957 34.2553 12.9529 34.0492 13.1332C33.8431 13.3135 33.6319 13.584 33.3073 13.2543C32.9827 12.9245 31.8002 13.5789 32.2536 14.3028Z"
        fill="#111111"
      />
      <path
        d="M33.7898 16.4433C33.7615 16.4074 33.7432 16.3646 33.7369 16.3194C33.7305 16.2741 33.7363 16.2279 33.7537 16.1857C33.8104 16.0517 33.9212 15.8714 34.1041 15.8971C34.287 15.9229 34.3283 16.2269 34.1994 16.4124C34.1754 16.4439 34.1444 16.4694 34.1089 16.487C34.0734 16.5046 34.0343 16.5137 33.9946 16.5137C33.955 16.5137 33.9159 16.5046 33.8804 16.487C33.8448 16.4694 33.8139 16.4439 33.7898 16.4124V16.4433Z"
        fill="#F4A28C"
      />
      <path
        d="M19.9968 34.2636L19.6455 34.8178C19.5306 34.9971 19.4685 35.2053 19.4664 35.4183C19.4644 35.6313 19.5224 35.8406 19.6338 36.0222C19.8041 36.3008 20.0339 36.538 20.2919 36.4538C20.8473 36.2683 20.753 34.8318 20.753 34.8318L19.9968 34.2636Z"
        fill="#F4A28C"
      />
      <path
        d="M40.9666 19.0331C42.6231 19.1774 44.7227 20.6149 46.1551 26.061L41.1315 27.8643L38.9933 21.5964C38.8895 21.2933 38.8624 20.9692 38.9144 20.6531C38.9664 20.3369 39.096 20.0386 39.2914 19.7847C39.4869 19.5308 39.7421 19.3293 40.0345 19.1982C40.3268 19.067 40.647 19.0103 40.9666 19.0331Z"
        fill="#008B07"
      />
      <path
        opacity="0.46"
        d="M40.9666 19.0331C42.6231 19.1774 44.7227 20.6149 46.1551 26.061L41.1315 27.8643L38.9933 21.5964C38.8895 21.2933 38.8624 20.9692 38.9144 20.6531C38.9664 20.3369 39.096 20.0386 39.2914 19.7847C39.4869 19.5308 39.7421 19.3293 40.0345 19.1982C40.3268 19.067 40.647 19.0103 40.9666 19.0331Z"
        fill="white"
      />
      <path
        d="M45.8844 26.0608L47.0488 30.2059C47.324 31.1875 47.2097 32.2375 46.7298 33.1369C46.2498 34.0363 45.4413 34.7158 44.4727 35.0337L40.9484 35.9148C40.7575 35.9609 40.5821 36.0567 40.4401 36.1924C40.298 36.3282 40.1943 36.499 40.1395 36.6876C40.0313 37.0612 39.8458 37.4605 39.5392 37.4373C38.2692 37.3239 39.48 35.518 39.48 35.518L42.9218 33.3695C43.3463 33.1039 43.6559 32.6888 43.7895 32.2062C43.923 31.7236 43.8708 31.2084 43.6431 30.7624L42.0021 27.573L45.8844 26.0608Z"
        fill="#F4A28C"
      />
      <path
        d="M20.002 46.616C20.002 47.3307 20.2142 48.0294 20.612 48.6238C21.0098 49.2182 21.5751 49.6817 22.2367 49.9557C22.8984 50.2297 23.6265 50.3019 24.3292 50.1633C25.032 50.0246 25.6778 49.6813 26.185 49.1767C26.6923 48.6721 27.0383 48.0288 27.1794 47.3281C27.3205 46.6273 27.2502 45.9006 26.9776 45.2397C26.705 44.5788 26.2421 44.0133 25.6475 43.6147C25.053 43.216 24.3533 43.0021 23.637 43C23.1603 42.9989 22.688 43.0917 22.2472 43.2729C21.8064 43.4541 21.4057 43.7202 21.0681 44.0561C20.7305 44.3919 20.4625 44.7909 20.2796 45.2301C20.0967 45.6694 20.0023 46.1403 20.002 46.616Z"
        fill="white"
      />
      <path
        d="M20.002 46.6162C20.0022 45.9001 20.2156 45.2002 20.615 44.6052C21.0145 44.0103 21.582 43.547 22.2456 43.2742C22.9092 43.0014 23.639 42.9314 24.3426 43.0729C25.0461 43.2145 25.6917 43.5613 26.1975 44.0693C26.7033 44.5774 27.0465 45.2238 27.1836 45.9268C27.3207 46.6297 27.2456 47.3574 26.9677 48.0176C26.6898 48.6778 26.2217 49.2409 25.6227 49.6354C25.0237 50.0299 24.3208 50.238 23.6031 50.2335C22.6453 50.2288 21.7283 49.8455 21.0533 49.1674C20.3782 48.4893 20.0002 47.5719 20.002 46.6162ZM25.8657 45.4874C25.8296 45.0411 25.7447 44.6 25.6124 44.1722C25.6058 44.1549 25.5933 44.1406 25.5771 44.1316C25.2303 43.9162 24.8632 43.7351 24.4811 43.5909C24.462 43.5855 24.4419 43.5855 24.4228 43.5909L23.9906 43.7261C23.6994 43.8137 23.4218 43.9411 23.1655 44.1046C23.1557 44.1082 23.1476 44.1153 23.1426 44.1245C23.1376 44.1337 23.1361 44.1444 23.1384 44.1546C23.2021 44.5723 23.2644 44.99 23.3281 45.4063C23.33 45.415 23.3335 45.4231 23.3387 45.4303C23.3438 45.4375 23.3503 45.4436 23.3579 45.4482C23.8095 45.6663 24.2584 45.883 24.7046 46.0984C24.7211 46.1052 24.7396 46.1052 24.7561 46.0984L25.84 45.5158C25.8481 45.5172 25.8562 45.4996 25.8657 45.4874ZM21.705 46.5418L22.1602 46.5648C22.1769 46.5657 22.1933 46.5604 22.2063 46.5499C22.5477 46.1976 22.8873 45.8443 23.2251 45.4901C23.2353 45.4786 23.2407 45.4636 23.24 45.4482C23.1795 45.0364 23.1177 44.6241 23.0544 44.2114C23.0463 44.1519 23.0463 44.1519 22.9826 44.1438C22.6437 44.0931 22.3005 44.0768 21.9584 44.0951C21.9353 44.0964 21.9133 44.1055 21.896 44.1208C21.5677 44.4243 21.2616 44.7509 20.9802 45.0981C20.9703 45.1113 20.9655 45.1276 20.9666 45.1441C20.9869 45.2941 21.0086 45.4428 21.0303 45.5915C21.0722 45.8928 21.1305 46.1915 21.2051 46.4864C21.2051 46.5067 21.2145 46.5202 21.2416 46.5215C21.3961 46.5256 21.5505 46.5337 21.705 46.5418ZM25.8955 45.5956L25.8603 45.6145L24.8008 46.1849C24.788 46.1909 24.7771 46.2001 24.7692 46.2118C24.7613 46.2235 24.7568 46.2371 24.7561 46.2512C24.7209 46.5215 24.6829 46.7919 24.6464 47.0555C24.6166 47.2637 24.5881 47.4732 24.561 47.6827C24.5598 47.6919 24.5606 47.7013 24.5634 47.7102C24.5662 47.7191 24.571 47.7272 24.5773 47.7341L25.2899 48.3721C25.2962 48.3764 25.3033 48.3794 25.3107 48.3808C25.3182 48.3822 25.3259 48.382 25.3333 48.3802C25.7305 48.2492 26.1049 48.0572 26.4429 47.8111C26.4685 47.7932 26.486 47.7661 26.4917 47.7354C26.5557 47.4289 26.6009 47.1188 26.6272 46.8068C26.6303 46.7768 26.6257 46.7465 26.6136 46.7189C26.5228 46.5364 26.4361 46.3526 26.3426 46.1782C26.2154 45.9683 26.0654 45.7729 25.8955 45.5956ZM21.6725 46.6297L21.2173 46.6094C21.2091 46.6099 21.2012 46.612 21.194 46.6158C21.1867 46.6195 21.1804 46.6247 21.1753 46.631C21.1305 46.7 21.0872 46.7662 21.0398 46.8405C20.913 47.0859 20.8192 47.3467 20.7607 47.6165C20.759 47.6295 20.7613 47.6427 20.7674 47.6543C20.9192 47.9731 21.0879 48.2835 21.2728 48.5843C21.2837 48.5995 21.2988 48.6113 21.3162 48.6181C21.4842 48.6654 21.6522 48.7182 21.8242 48.7533C22.0747 48.8002 22.3297 48.8188 22.5843 48.8087C22.61 48.8087 22.6114 48.7912 22.6182 48.7749C22.7085 48.5307 22.7957 48.286 22.8797 48.0409C22.885 48.0309 22.8878 48.0198 22.8878 48.0085C22.8878 47.9972 22.885 47.986 22.8797 47.976L22.1846 46.6797C22.1803 46.6701 22.1732 46.662 22.1643 46.6565C22.1554 46.651 22.145 46.6482 22.1345 46.6486L21.6725 46.6297ZM23.6763 49.6414H23.6953C24.0454 49.6063 24.3924 49.5443 24.7331 49.4562C24.7486 49.4514 24.7623 49.442 24.7724 49.4292C24.9841 49.1453 25.1408 48.8243 25.2344 48.483C25.2383 48.4721 25.2386 48.4603 25.2351 48.4494C25.2317 48.4384 25.2248 48.4288 25.2154 48.4221C24.986 48.2194 24.7602 48.0161 24.538 47.8125C24.5266 47.8012 24.5125 47.7932 24.497 47.7892C24.4816 47.7851 24.4653 47.7853 24.4499 47.7895L23.026 48.0436C23.0143 48.0446 23.0032 48.0492 22.9943 48.0567C22.9853 48.0642 22.9789 48.0743 22.9758 48.0855C22.8918 48.3234 22.8078 48.56 22.7211 48.7966C22.7151 48.811 22.7131 48.8269 22.7155 48.8424C22.7179 48.8579 22.7245 48.8724 22.7347 48.8844C22.973 49.2086 23.2907 49.4665 23.6573 49.6333C23.6634 49.6366 23.6697 49.6394 23.6763 49.6414ZM20.3447 45.3374L20.3935 45.3171L20.8393 45.1157C20.8614 45.1047 20.8812 45.0896 20.8975 45.0711C21.1994 44.7023 21.5262 44.3545 21.8757 44.0302C21.8892 44.0169 21.8994 44.0007 21.9055 43.9829L22.0234 43.6842L22.1196 43.4408C21.3093 43.8245 20.6754 44.501 20.3461 45.3333L20.3447 45.3374ZM27.0241 45.7253L27.0119 45.7605C26.9216 46.0362 26.834 46.312 26.7491 46.5878C26.7344 46.6228 26.7244 46.6596 26.7193 46.6973C26.6919 47.0611 26.6385 47.4225 26.5594 47.7787C26.5497 47.8139 26.5451 47.8503 26.5459 47.8868C26.5635 48.0301 26.5852 48.172 26.6055 48.3153C26.6055 48.3586 26.6177 48.4032 26.6258 48.4573C26.8987 48.0147 27.0691 47.5168 27.1244 47.0001C27.1731 46.5727 27.139 46.1399 27.0241 45.7253ZM23.1493 50.097C23.578 50.1557 24.0138 50.135 24.435 50.0361C24.8525 49.9388 25.2479 49.7636 25.6002 49.5198C25.359 49.5103 25.1179 49.5062 24.878 49.5022C24.8643 49.5031 24.8507 49.5054 24.8374 49.509C24.489 49.6025 24.1339 49.6694 23.7752 49.709C23.7206 49.709 23.6672 49.7255 23.6221 49.7563C23.4785 49.8645 23.3308 49.9658 23.1845 50.0699L23.1493 50.097ZM21.3351 49.2859C21.3351 49.2697 21.3351 49.2629 21.3351 49.2575C21.3107 49.0953 21.2877 48.9344 21.2633 48.7736C21.2602 48.7337 21.2496 48.6947 21.2322 48.6587C21.0343 48.3339 20.8534 47.9991 20.6902 47.6557C20.6822 47.6397 20.6717 47.6251 20.6591 47.6124L20.1767 47.1961L20.1523 47.1798C20.224 47.6259 20.3819 48.0537 20.6171 48.4397C20.8101 48.757 21.052 49.0421 21.3338 49.2846L21.3351 49.2859ZM24.0231 43.1245L24.0421 43.1448C24.1681 43.257 24.2928 43.3706 24.4188 43.4814C24.4312 43.492 24.4454 43.5002 24.4608 43.5057C24.8716 43.657 25.2665 43.8485 25.6395 44.0775C25.6667 44.0928 25.6966 44.1029 25.7275 44.1073C25.7885 44.1154 25.8508 44.1208 25.9131 44.1262L26.1177 44.1451C25.5581 43.5745 24.8183 43.214 24.0231 43.1245Z"
        fill="#111111"
      />
      <path
        d="M25.8646 45.4873C25.8552 45.4995 25.847 45.517 25.8335 45.5238L24.7496 46.1064C24.7331 46.1132 24.7146 46.1132 24.6981 46.1064C24.2465 45.8919 23.7976 45.6752 23.3514 45.4562C23.3438 45.4516 23.3373 45.4455 23.3322 45.4383C23.327 45.4311 23.3234 45.423 23.3216 45.4143C23.2579 44.998 23.1956 44.5803 23.1319 44.1626C23.1296 44.1524 23.1311 44.1417 23.1361 44.1325C23.1411 44.1233 23.1492 44.1162 23.159 44.1126C23.4153 43.9491 23.6929 43.8217 23.9841 43.7341L24.4163 43.5989C24.4354 43.5935 24.4555 43.5935 24.4746 43.5989C24.8567 43.743 25.2238 43.9241 25.5706 44.1396C25.5868 44.1486 25.5993 44.1629 25.6059 44.1801C25.7394 44.6052 25.8262 45.0435 25.8646 45.4873Z"
        fill="white"
      />
      <path
        d="M21.7053 46.5416C21.5509 46.5335 21.3964 46.5254 21.242 46.52C21.2149 46.52 21.2108 46.5051 21.2054 46.4848C21.1309 46.1899 21.0726 45.8912 21.0306 45.59C21.009 45.4413 20.9873 45.2926 20.967 45.1425C20.9658 45.1261 20.9706 45.1098 20.9805 45.0966C21.262 44.7493 21.568 44.4227 21.8964 44.1192C21.9137 44.1039 21.9356 44.0949 21.9587 44.0936C22.3009 44.0753 22.6441 44.0916 22.983 44.1422C23.0466 44.1503 23.0466 44.1503 23.0548 44.2098C23.1171 44.6225 23.179 45.0348 23.2404 45.4467C23.241 45.462 23.2357 45.4771 23.2255 45.4886C22.8868 45.8427 22.5472 46.196 22.2066 46.5484C22.1936 46.5588 22.1772 46.5641 22.1606 46.5632L21.7053 46.5403V46.5416Z"
        fill="white"
      />
      <path
        d="M25.8946 45.5953C26.0644 45.7718 26.2143 45.9663 26.3417 46.1752C26.4406 46.3523 26.5274 46.5362 26.6127 46.716C26.6248 46.7436 26.6294 46.7739 26.6263 46.8038C26.6001 47.1158 26.5548 47.426 26.4908 47.7325C26.4851 47.7631 26.4676 47.7903 26.442 47.8082C26.104 48.0543 25.7297 48.2463 25.3324 48.3773C25.325 48.379 25.3173 48.3792 25.3098 48.3778C25.3024 48.3764 25.2953 48.3735 25.289 48.3692L24.5764 47.7311C24.5701 47.7243 24.5653 47.7161 24.5625 47.7073C24.5597 47.6984 24.5589 47.689 24.5601 47.6798C24.5872 47.4702 24.6157 47.2607 24.6455 47.0525C24.6821 46.7822 24.72 46.5118 24.7552 46.2482C24.7559 46.2342 24.7604 46.2206 24.7683 46.2089C24.7762 46.1972 24.7871 46.1879 24.7999 46.182L25.8594 45.6116L25.8946 45.5953Z"
        fill="white"
      />
      <path
        d="M21.6727 46.6295L22.1361 46.6525C22.1466 46.6521 22.157 46.6549 22.1659 46.6604C22.1748 46.6659 22.1819 46.674 22.1862 46.6836L22.8812 47.9799C22.8866 47.9899 22.8894 48.0011 22.8894 48.0124C22.8894 48.0237 22.8866 48.0348 22.8812 48.0448C22.7909 48.2899 22.7038 48.5346 22.6198 48.7788C22.6198 48.795 22.6116 48.8126 22.5859 48.8126C22.3312 48.8226 22.0763 48.8041 21.8258 48.7572C21.6538 48.718 21.4858 48.6653 21.3177 48.622C21.3003 48.6151 21.2853 48.6034 21.2744 48.5882C21.0895 48.2874 20.9208 47.9769 20.769 47.6582C20.7629 47.6466 20.7605 47.6334 20.7623 47.6204C20.8208 47.3506 20.9146 47.0897 21.0414 46.8444C21.082 46.7728 21.1254 46.7093 21.1768 46.6349C21.1819 46.6286 21.1883 46.6234 21.1955 46.6197C21.2028 46.6159 21.2107 46.6138 21.2188 46.6133L21.6741 46.6336L21.6727 46.6295Z"
        fill="white"
      />
      <path
        d="M23.6772 49.6412C23.6687 49.6395 23.6605 49.6368 23.6528 49.6331C23.2861 49.4662 22.9685 49.2084 22.7301 48.8842C22.72 48.8722 22.7133 48.8577 22.711 48.8422C22.7086 48.8267 22.7105 48.8108 22.7166 48.7963C22.8033 48.5598 22.8873 48.3232 22.9713 48.0853C22.9743 48.074 22.9808 48.064 22.9897 48.0565C22.9987 48.049 23.0098 48.0444 23.0214 48.0434L24.4508 47.7893C24.4662 47.785 24.4824 47.7849 24.4979 47.789C24.5134 47.793 24.5275 47.801 24.5388 47.8123C24.7656 48.0159 24.9914 48.2191 25.2163 48.4219C25.2257 48.4286 25.2326 48.4382 25.236 48.4491C25.2394 48.4601 25.2392 48.4719 25.2352 48.4827C25.1417 48.8241 24.985 49.1451 24.7732 49.429C24.7632 49.4418 24.7495 49.4512 24.7339 49.456C24.3933 49.5441 24.0463 49.606 23.6961 49.6412H23.6772Z"
        fill="white"
      />
      <path
        d="M20.3438 45.337C20.6731 44.5046 21.307 43.8282 22.1172 43.4445L22.021 43.6878L21.9032 43.9865C21.897 44.0044 21.8868 44.0206 21.8734 44.0338C21.5243 44.3582 21.198 44.7059 20.8965 45.0747C20.8802 45.0932 20.8604 45.1084 20.8383 45.1193L20.3925 45.3207L20.3438 45.337Z"
        fill="white"
      />
      <path
        d="M27.0242 45.7251C27.1386 46.1384 27.1727 46.5697 27.1245 46.9958C27.0692 47.5125 26.8988 48.0104 26.6259 48.453C26.6178 48.3989 26.611 48.3543 26.6056 48.3111C26.5853 48.1678 26.5636 48.0258 26.546 47.8825C26.5452 47.846 26.5498 47.8096 26.5595 47.7744C26.6386 47.4182 26.692 47.0568 26.7194 46.693C26.7245 46.6553 26.7346 46.6185 26.7492 46.5835C26.8395 46.3077 26.9271 46.032 27.012 45.7562L27.0242 45.7251Z"
        fill="white"
      />
      <path
        d="M23.1504 50.0969L23.1856 50.0698C23.3319 49.9657 23.4796 49.8643 23.6232 49.7562C23.6683 49.7254 23.7217 49.7089 23.7763 49.7089C24.135 49.6693 24.4901 49.6024 24.8385 49.5088C24.8518 49.5053 24.8654 49.503 24.8792 49.5021C25.119 49.5021 25.3601 49.5102 25.6013 49.5196C25.249 49.7635 24.8537 49.9387 24.4361 50.036C24.0149 50.1349 23.5791 50.1555 23.1504 50.0969Z"
        fill="white"
      />
      <path
        d="M21.3326 49.2845C21.0492 49.042 20.806 48.7564 20.6118 48.4383C20.3772 48.0526 20.2199 47.6253 20.1484 47.1798L20.1728 47.196L20.6551 47.611C20.6678 47.6237 20.6783 47.6383 20.6863 47.6543C20.8495 47.9977 21.0304 48.3325 21.2282 48.6573C21.2457 48.6933 21.2563 48.7323 21.2594 48.7722C21.2838 48.9331 21.3068 49.0939 21.3312 49.2561C21.3326 49.2615 21.3326 49.2683 21.3326 49.2845Z"
        fill="white"
      />
      <path
        d="M24.0225 43.1243C24.8176 43.2137 25.5574 43.5742 26.1171 44.1449L25.9125 44.1259C25.8501 44.1259 25.7878 44.1151 25.7269 44.107C25.6959 44.1027 25.666 44.0926 25.6388 44.0773C25.2658 43.8483 24.871 43.6567 24.4601 43.5055C24.4447 43.4999 24.4305 43.4917 24.4181 43.4811C24.2921 43.3703 24.1674 43.2567 24.0414 43.1445L24.0225 43.1243Z"
        fill="white"
      />
    </SvgIcon>
  );
};

export const RuleStepIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "20", height: "20", fill: "none" }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M11.6663 9.16669H6.66634M8.33301 12.5H6.66634M13.333 5.83335H6.66634M16.6663 5.66669V14.3334C16.6663 15.7335 16.6663 16.4336 16.3939 16.9683C16.1542 17.4387 15.7717 17.8212 15.3013 18.0609C14.7665 18.3334 14.0665 18.3334 12.6663 18.3334H7.33301C5.93288 18.3334 5.23281 18.3334 4.69803 18.0609C4.22763 17.8212 3.84517 17.4387 3.60549 16.9683C3.33301 16.4336 3.33301 15.7335 3.33301 14.3334V5.66669C3.33301 4.26656 3.33301 3.56649 3.60549 3.03171C3.84517 2.56131 4.22763 2.17885 4.69803 1.93917C5.23281 1.66669 5.93288 1.66669 7.33301 1.66669H12.6663C14.0665 1.66669 14.7665 1.66669 15.3013 1.93917C15.7717 2.17885 16.1542 2.56131 16.3939 3.03171C16.6663 3.56649 16.6663 4.26656 16.6663 5.66669Z"
        stroke="#008B07"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const DetailsStepIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "20", height: "20", fill: "none" }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M11.6663 1.8913V5.33341C11.6663 5.80012 11.6663 6.03348 11.7572 6.21174C11.8371 6.36854 11.9645 6.49602 12.1213 6.57592C12.2996 6.66675 12.533 6.66675 12.9997 6.66675H16.4418M7.49967 13.3334L9.16634 15L12.9163 11.25M11.6663 1.66669H7.33301C5.93288 1.66669 5.23281 1.66669 4.69803 1.93917C4.22763 2.17885 3.84517 2.56131 3.60549 3.03171C3.33301 3.56649 3.33301 4.26656 3.33301 5.66669V14.3334C3.33301 15.7335 3.33301 16.4336 3.60549 16.9683C3.84517 17.4387 4.22763 17.8212 4.69803 18.0609C5.23281 18.3334 5.93288 18.3334 7.33301 18.3334H12.6663C14.0665 18.3334 14.7665 18.3334 15.3013 18.0609C15.7717 17.8212 16.1542 17.4387 16.3939 16.9683C16.6663 16.4336 16.6663 15.7335 16.6663 14.3334V6.66669L11.6663 1.66669Z"
        stroke="#008B07"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const DateStepIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "20", height: "20", fill: "none" }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M17.5 8.33335H2.5M13.3333 1.66669V5.00002M6.66667 1.66669V5.00002M7.5 13.3334L9.16667 15L12.9167 11.25M6.5 18.3334H13.5C14.9001 18.3334 15.6002 18.3334 16.135 18.0609C16.6054 17.8212 16.9878 17.4387 17.2275 16.9683C17.5 16.4336 17.5 15.7335 17.5 14.3334V7.33335C17.5 5.93322 17.5 5.23316 17.2275 4.69838C16.9878 4.22797 16.6054 3.84552 16.135 3.60584C15.6002 3.33335 14.9001 3.33335 13.5 3.33335H6.5C5.09987 3.33335 4.3998 3.33335 3.86502 3.60584C3.39462 3.84552 3.01217 4.22797 2.77248 4.69838C2.5 5.23316 2.5 5.93322 2.5 7.33335V14.3334C2.5 15.7335 2.5 16.4336 2.77248 16.9683C3.01217 17.4387 3.39462 17.8212 3.86502 18.0609C4.3998 18.3334 5.09987 18.3334 6.5 18.3334Z"
        stroke="#008B07"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const InviteStepIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "20", height: "20", fill: "none" }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M15.8337 17.5V12.5M13.3337 15H18.3337M10.0003 12.5H6.66699C5.11385 12.5 4.33728 12.5 3.72471 12.7537C2.90795 13.092 2.25904 13.741 1.92073 14.5577C1.66699 15.1703 1.66699 15.9469 1.66699 17.5M12.917 2.7423C14.1386 3.23679 15.0003 4.43443 15.0003 5.83333C15.0003 7.23224 14.1386 8.42988 12.917 8.92437M11.2503 5.83333C11.2503 7.67428 9.75794 9.16667 7.91699 9.16667C6.07604 9.16667 4.58366 7.67428 4.58366 5.83333C4.58366 3.99238 6.07604 2.5 7.91699 2.5C9.75794 2.5 11.2503 3.99238 11.2503 5.83333Z"
        stroke="#008B07"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const ConfirmStepIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "25", height: "25", fill: "none" }}
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
    >
      <circle cx="13" cy="13" r="12.5" fill="#106048" />
      <path
        d="M18.625 9.43047L17.507 8.3125L11.2685 14.5451L8.81245 12.089L7.6875 13.2061L11.2685 16.787L18.625 9.43047Z"
        fill="white"
      />
    </SvgIcon>
  );
};

export const ExitPopUpIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "21", height: "24", fill: "none" }}
      width="21"
      height="25"
      viewBox="0 0 21 25"
      fill="none"
    >
      <path
        d="M14.875 7L6.125 17M6.125 7L14.875 17"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const CreateNowIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "20", height: "20", fill: "none" }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M4.16699 10H15.8337M15.8337 10L10.0003 4.16669M15.8337 10L10.0003 15.8334"
        stroke="#106048"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const CompletedStepIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "24", height: "24", fill: "none" }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clipPath="url(#clip0_29654_22627)">
        <rect width="24" height="24" rx="12" fill="#008B07" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.096 7.39004L9.93602 14.3L8.03602 12.27C7.68602 11.94 7.13602 11.92 6.73602 12.2C6.34602 12.49 6.23602 13 6.47602 13.41L8.72602 17.07C8.94602 17.41 9.32601 17.62 9.75601 17.62C10.166 17.62 10.556 17.41 10.776 17.07C11.136 16.6 18.006 8.41004 18.006 8.41004C18.906 7.49004 17.816 6.68004 17.096 7.38004V7.39004Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_29654_22627">
          <rect width="24" height="24" rx="12" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export const ActiveStepIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "25", height: "24", fill: "none" }}
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <g clipPath="url(#clip0)">
        <rect x="0.1" width="24" height="24" rx="12" fill="#D9DAD2" />
        <rect x="0.1" width="24" height="24" rx="12" fill="#E7EFED" />
        <circle cx="12.1" cy="12" r="4" fill="#106048" />
      </g>
      <rect x="1.6" y="1.5" width="21" height="21" rx="10.5" stroke="#D9DAD2" strokeWidth="3" />
      <defs>
        <clipPath id="clip0">
          <rect x="0.1" width="24" height="24" rx="12" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export const InactiveStepIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "25", height: "24", fill: "none" }}
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <g clipPath="url(#clip0)">
        <rect x="0.44" width="24" height="24" rx="12" fill="#F5F6F5" />
        <circle cx="12.44" cy="12" r="4" fill="#CFCFCF" />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect x="0.44" width="24" height="24" rx="12" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export const LocationIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{
        width: "12",
        height: "12",
        fill: "none",
        position: "relative",
        transform: "translateY(20%)",
      }}
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <g clipPath="url(#clip0_26056_4014)">
        <path
          d="M2 6C2 8.20914 3.79086 10 6 10M2 6C2 3.79086 3.79086 2 6 2M2 6H1M6 10C8.20914 10 10 8.20914 10 6M6 10V11M10 6C10 3.79086 8.20914 2 6 2M10 6H11M6 2V1M4.5 6C4.5 6.82843 5.17157 7.5 6 7.5C6.82843 7.5 7.5 6.82843 7.5 6C7.5 5.17157 6.82843 4.5 6 4.5C5.17157 4.5 4.5 5.17157 4.5 6Z"
          stroke="#106048"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_26056_4014">
          <rect width="12" height="12" fill="white" transform="matrix(-1 0 0 1 12 0)" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export const LocatorIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{
        width: "20",
        height: "20",
        fill: "none",
        position: "relative",
        transform: "translateY(20%)",
      }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path d="M9.18262 9.19098V18.7744L9.99958 19.9999V9.19098H9.18262Z" fill="#106048" />
      <path d="M10 9.19098V19.9999L10.817 18.7744V9.19098H10Z" fill="#106048" />
      <path
        d="M14.698 4.69766C14.698 7.29364 12.5943 9.39532 10.0004 9.39532C7.82927 9.39532 6.00123 7.92269 5.46409 5.92108C5.35787 5.53098 5.30273 5.12248 5.30273 4.69766C5.30269 2.10373 7.40641 0 10.0003 0C11.4546 0 12.7536 0.659715 13.6135 1.69727C14.2916 2.51018 14.698 3.55799 14.698 4.69766Z"
        fill="#106048"
      />
      <path
        d="M13.7749 2.91869C13.7749 5.51262 11.6711 7.61634 9.07721 7.61634C7.62299 7.61634 6.32603 6.95663 5.46409 5.92108C5.35787 5.53098 5.30273 5.12248 5.30273 4.69766C5.30273 2.10373 7.40646 0 10.0004 0C11.4546 0 12.7536 0.659715 13.6135 1.69727C13.7197 2.08741 13.7749 2.49592 13.7749 2.91869Z"
        fill="#106048"
      />
      <path
        d="M11.2353 2.19769C11.2735 1.85355 11.012 1.54485 10.6724 1.47763C9.84681 1.31427 7.83374 1.16953 6.94844 3.35077C6.94844 3.35077 6.73259 3.91205 7.35319 3.84188C7.65227 3.80805 7.91959 3.64375 8.10785 3.4089C8.41355 3.02747 9.13905 2.40649 10.4877 2.6999C10.8044 2.76879 11.1425 2.59394 11.2207 2.27943C11.2272 2.2533 11.2321 2.22605 11.2353 2.19769Z"
        fill="white"
      />
    </SvgIcon>
  );
};

export const LocationInputEndIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "24", height: "24", fill: "none" }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M20 12C20 16.4183 16.4183 20 12 20M20 12C20 7.58172 16.4183 4 12 4M20 12H22M12 20C7.58172 20 4 16.4183 4 12M12 20V22M4 12C4 7.58172 7.58172 4 12 4M4 12H2M12 4V2M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z"
        stroke="#106048"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const LocationInputPlaceholderIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "14.4", height: "17.7", fill: "none" }}
      width="14.4"
      height="17.7"
      viewBox="0 0 14.4 17.7"
      fill="none"
    >
      <path
        d="M15.1998 7.2C15.1998 3.20983 11.8998 0 7.9998 0C4.00963 0 0.799805 3.21 0.799805 7.2V7.5C0.799805 7.53 0.919805 8.58 1.0398 9.03C1.8798 12.5402 4.72963 15.21 7.9998 17.7002C11.2698 15.2102 14.1198 12.5402 14.9598 9.03C15.0798 8.58 15.1998 7.56 15.1998 7.5V7.2ZM7.9998 10.2C6.3498 10.2 4.9998 8.85 4.9998 7.2C4.9998 5.55 6.3498 4.2 7.9998 4.2C9.64981 4.2 10.9998 5.55 10.9998 7.2C10.9998 8.85 9.64981 10.2 7.9998 10.2Z"
        fill="#A0A0A0"
      />
    </SvgIcon>
  );
};

export const DeleteUserIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "10", height: "10", fill: "none" }}
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
    >
      <path d="M8.5 1.5L1.5 8.5M8.5 8.5L1.5 1.5" stroke="white" strokeWidth="1.4" strokeLinecap="round" />
    </SvgIcon>
  );
};

export const EmptyListFigure = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "158", height: "121", fill: "none" }}
      width="158"
      height="121"
      viewBox="0 0 158 121"
      fill="none"
    >
      <path d="M128.497 22.0287H44.5994V80.8607H128.497V22.0287Z" fill="#E7E7E7" />
      <path d="M88.3972 27.5409H51.7017V72.8236H88.3972V27.5409Z" fill="#CFCFCF" />
      <g opacity="0.39">
        <path d="M75.5318 34.6327H71.9768V35.7655H75.5318V34.6327Z" fill="#F5F6F5" />
        <path d="M85.628 34.6327H76.7405V35.7655H85.628V34.6327Z" fill="#F5F6F5" />
        <path d="M80.8288 38.2942H71.9768V39.427H80.8288V38.2942Z" fill="#F5F6F5" />
        <path d="M85.628 38.2942H81.9663V39.427H85.628V38.2942Z" fill="#F5F6F5" />
        <path d="M85.6281 41.9558H76.4207V43.0886H85.6281V41.9558Z" fill="#F5F6F5" />
        <path d="M75.4252 41.9558H71.9768V43.0886H75.4252V41.9558Z" fill="#F5F6F5" />
        <path d="M82.5352 45.6133H71.9768V46.746H82.5352V45.6133Z" fill="#F5F6F5" />
      </g>
      <path opacity="0.39" d="M68.6708 34.6327H54.7036V50.1803H68.6708V34.6327Z" fill="#F5F6F5" />
      <path d="M88.3972 27.5409H51.7017V31.6891H88.3972V27.5409Z" fill="#106048" />
      <path opacity="0.39" d="M85.6282 54.0013H73.6123V55.0464H85.6282V54.0013Z" fill="#F5F6F5" />
      <path opacity="0.39" d="M72.1903 54.0013H54.7036V55.0464H72.1903V54.0013Z" fill="#F5F6F5" />
      <path opacity="0.39" d="M85.6282 58.0139H77.0962V59.0589H85.6282V58.0139Z" fill="#F5F6F5" />
      <path opacity="0.39" d="M75.3898 58.0139H54.7036V59.0589H75.3898V58.0139Z" fill="#F5F6F5" />
      <path opacity="0.39" d="M65.2264 62.0264H54.7036V63.0714H65.2264V62.0264Z" fill="#F5F6F5" />
      <path opacity="0.39" d="M85.6281 62.0264H68.0703V63.0714H85.6281V62.0264Z" fill="#F5F6F5" />
      <path opacity="0.39" d="M81.6466 66.0391H54.7036V67.0841H81.6466V66.0391Z" fill="#F5F6F5" />
      <path
        d="M63.8162 38.9842C63.8162 38.9842 64.3337 41.4851 64.1085 43.2201C64.0867 43.3879 64.0322 43.5497 63.9482 43.6962C63.8642 43.8426 63.7523 43.9709 63.6191 44.0736C63.4858 44.1762 63.3338 44.2513 63.1717 44.2945C63.0097 44.3376 62.8407 44.348 62.6747 44.325C61.8136 44.1973 60.6997 43.7745 60.2454 42.4663L59.25 40.3324C59.0911 39.8854 59.0738 39.3996 59.2005 38.9422C59.3272 38.4848 59.5916 38.0786 59.9571 37.7797C61.225 36.5911 63.595 37.4366 63.8162 38.9842Z"
        fill="#F4A28C"
      />
      <path d="M59.416 40.7192L59.0881 49.0913L63.6701 48.9438L62.0664 42.913L59.416 40.7192Z" fill="#F4A28C" />
      <path
        d="M63.1999 39.1597C62.4267 39.2825 61.642 39.3146 60.8615 39.2555C61.1256 39.5745 61.2919 39.9643 61.3403 40.3772C61.3887 40.7901 61.3171 41.2083 61.1341 41.5808C60.9627 41.9431 60.6721 42.2342 60.312 42.4044C59.9518 42.5746 59.5444 42.6134 59.1591 42.5141L58.8154 39.2475C58.7524 38.782 58.8145 38.3079 58.9952 37.875C59.1758 37.442 59.4685 37.0661 59.8424 36.7865C60.1679 36.5443 60.5083 36.3231 60.8615 36.1244C61.7463 35.6378 63.1802 36.1005 63.9425 35.3666C64.019 35.293 64.1132 35.2409 64.2157 35.2153C64.3182 35.1896 64.4255 35.1914 64.5272 35.2204C64.6288 35.2494 64.7212 35.3046 64.7953 35.3805C64.8694 35.4565 64.9226 35.5507 64.9498 35.6537C65.2105 36.627 65.2184 38.2104 63.9544 38.9124C63.7184 39.0371 63.4634 39.1207 63.1999 39.1597V39.1597Z"
        fill="#111111"
      />
      <path
        d="M61.4028 41.4732C61.4028 41.4732 61.2685 40.496 60.5496 40.6755C59.8307 40.8549 60.0164 42.247 61.0197 42.2709L61.4028 41.4732Z"
        fill="#F4A28C"
      />
      <path
        d="M64.0612 40.5797L64.8788 41.4772C64.9276 41.5267 64.9625 41.5884 64.9803 41.6559C64.998 41.7234 64.9978 41.7944 64.9798 41.8619C64.9618 41.9293 64.9266 41.9908 64.8777 42.0402C64.8288 42.0896 64.7679 42.1251 64.7011 42.1432L63.761 42.4424L64.0612 40.5797Z"
        fill="#F4A28C"
      />
      <path
        opacity="0.31"
        d="M62.4733 44.2173C61.8893 44.1416 61.34 43.8948 60.8933 43.5073C60.8933 43.5073 61.1382 45.023 62.971 46.3273L62.4733 44.2173Z"
        fill="#CE8172"
      />
      <path
        d="M60.1783 47.7871H63.2C63.4557 47.7871 63.709 47.838 63.9452 47.9368C64.1815 48.0356 64.3962 48.1805 64.577 48.363C64.7578 48.5456 64.9013 48.7624 64.9991 49.001C65.097 49.2396 65.1474 49.4953 65.1474 49.7535V50.1922H58.2349V49.7535C58.2349 49.4953 58.2852 49.2396 58.3831 49.001C58.481 48.7624 58.6244 48.5456 58.8052 48.363C58.9861 48.1805 59.2007 48.0356 59.437 47.9368C59.6733 47.838 59.9265 47.7871 60.1822 47.7871H60.1783Z"
        fill="#106048"
      />
      <path opacity="0.08" d="M125.215 38.4059H95.27V75.3524H125.215V38.4059Z" fill="#111111" />
      <path d="M122.308 34.7404H92.3628V71.6869H122.308V34.7404Z" fill="#CFCFCF" />
      <g opacity="0.39">
        <path d="M111.805 40.5278H108.906V41.4492H111.805V40.5278Z" fill="#F5F6F5" />
        <path d="M120.044 40.5278H112.792V41.4492H120.044V40.5278Z" fill="#F5F6F5" />
        <path d="M116.126 43.5153H108.906V44.4366H116.126V43.5153Z" fill="#F5F6F5" />
        <path d="M120.041 43.5153H117.054V44.4366H120.041V43.5153Z" fill="#F5F6F5" />
        <path d="M120.045 46.5028H112.532V47.4242H120.045V46.5028Z" fill="#F5F6F5" />
        <path d="M111.718 46.5028H108.906V47.4242H111.718V46.5028Z" fill="#F5F6F5" />
        <path d="M117.52 49.4902H108.906V50.4116H117.52V49.4902Z" fill="#F5F6F5" />
      </g>
      <path opacity="0.39" d="M106.211 40.5278H94.8118V53.2156H106.211V40.5278Z" fill="#F5F6F5" />
      <path d="M122.308 34.7404H92.3628V38.1267H122.308V34.7404Z" fill="#106048" />
      <path opacity="0.39" d="M120.044 56.3347H110.24V57.1883H120.044V56.3347Z" fill="#F5F6F5" />
      <path opacity="0.39" d="M109.083 56.3347H94.8118V57.1883H109.083V56.3347Z" fill="#F5F6F5" />
      <path opacity="0.39" d="M120.04 59.6055H113.081V60.459H120.04V59.6055Z" fill="#F5F6F5" />
      <path opacity="0.39" d="M111.69 59.6055H94.8118V60.459H111.69V59.6055Z" fill="#F5F6F5" />
      <path opacity="0.39" d="M103.395 62.8801H94.8118V63.7337H103.395V62.8801Z" fill="#F5F6F5" />
      <path opacity="0.39" d="M120.041 62.8801H105.714V63.7337H120.041V62.8801Z" fill="#F5F6F5" />
      <path opacity="0.39" d="M116.797 66.1548H94.8118V67.0083H116.797V66.1548Z" fill="#F5F6F5" />
      <path
        d="M102.992 43.9341C103.237 45.1339 103.322 46.3612 103.245 47.5837C103.226 47.728 103.178 47.867 103.106 47.9928C103.033 48.1187 102.936 48.2288 102.822 48.3169C102.707 48.4051 102.576 48.4695 102.436 48.5066C102.297 48.5437 102.152 48.5526 102.009 48.533C101.545 48.4986 101.1 48.3299 100.729 48.0469C100.358 47.7639 100.075 47.3787 99.9152 46.9375L99.0423 45.1028C98.9093 44.7172 98.8967 44.2997 99.0062 43.9067C99.1157 43.5137 99.342 43.164 99.6545 42.905C100.772 41.868 102.787 42.6059 102.992 43.9341Z"
        fill="#F4A28C"
      />
      <path d="M99.2001 45.4338L98.9197 52.6413L102.866 52.5176L101.487 47.3205L99.2001 45.4338Z" fill="#F4A28C" />
      <path
        d="M103.202 45.3062L103.905 46.076C103.945 46.1196 103.973 46.1728 103.987 46.2306C104.001 46.2884 104.001 46.3488 103.985 46.4062C103.97 46.4636 103.94 46.5162 103.899 46.5589C103.858 46.6016 103.807 46.633 103.751 46.6503L102.961 46.9096L103.202 45.3062Z"
        fill="#F4A28C"
      />
      <path
        opacity="0.31"
        d="M101.835 48.4452C101.334 48.3786 100.864 48.1666 100.48 47.835C100.48 47.835 100.69 49.1392 102.266 50.26L101.835 48.4452Z"
        fill="#CE8172"
      />
      <path
        d="M102.866 42.9729C102.866 42.9729 102.866 45.4179 100.618 45.4737C100.658 45.4737 100.539 46.8259 100.532 46.8937C100.413 47.831 100.654 48.7922 100.634 49.7495C100.644 49.9151 100.61 50.0803 100.536 50.2281C100.411 50.3861 100.237 50.4971 100.042 50.5432C98.9585 50.9017 97.8017 50.9704 96.6843 50.7427C96.5269 50.7332 96.3742 50.6849 96.2396 50.6019C96.105 50.519 95.9926 50.404 95.9123 50.2669C95.8319 50.1299 95.7861 49.9751 95.7789 49.816C95.7716 49.657 95.8031 49.4985 95.8706 49.3546C95.9567 48.8078 96.1037 48.2726 96.309 47.7592C96.4907 47.2965 96.7672 46.8777 96.945 46.423C97.3367 45.396 97.602 44.3244 97.735 43.2321C97.7634 42.8991 97.8324 42.5709 97.9404 42.2549C98.1316 41.8188 98.426 41.4366 98.7975 41.1421C99.1669 40.8635 99.6266 40.7353 100.085 40.7831C102.483 40.7353 103.056 41.7763 102.866 42.9729Z"
        fill="#111111"
      />
      <path
        d="M100.911 46.08C100.911 46.08 100.796 45.2424 100.176 45.382C99.5558 45.5216 99.7177 46.7342 100.571 46.7461L100.911 46.08Z"
        fill="#F4A28C"
      />
      <path
        d="M103.786 53.2754H97.7665V53.1637C97.7665 52.6348 97.9746 52.1275 98.345 51.7535C98.7154 51.3795 99.2177 51.1694 99.7415 51.1694H101.839C102.363 51.1694 102.865 51.3795 103.236 51.7535C103.606 52.1275 103.814 52.6348 103.814 53.1637V53.2754H103.786Z"
        fill="#106048"
      />
      <path
        opacity="0.08"
        d="M43.0551 51.0298C43.3343 50.9077 43.6206 50.8025 43.9122 50.7147C45.3409 50.3301 46.8142 50.1409 48.2928 50.1523C50.6628 50.0845 53.3567 50.1842 55.6003 51.0258C57.7254 51.8236 58.9775 53.8179 59.7438 55.872C59.9848 56.5142 60.0914 56.9729 60.8933 56.8612C63.5449 56.4876 66.0513 55.4114 68.1573 53.7421C70.0573 52.2264 71.7123 50.1882 74.0547 49.5859C74.2373 49.5283 74.4329 49.5283 74.6156 49.5859C74.9276 49.7056 75.0382 50.0965 75.0659 50.4315C75.1158 51.6332 74.7911 52.8203 74.1376 53.8258C73.4872 54.8223 72.7481 55.7569 71.9296 56.6179C69.5003 59.358 67.1896 62.2977 64.0296 64.1962C63.5468 64.4177 63.1408 64.7804 62.8643 65.2373C62.2995 66.5056 62.8406 78.9341 62.8643 81.0202H48.6443L42.0715 63.9529C40.8865 60.8977 38.1215 56.3746 40.3217 53.2076C41.0105 52.2353 41.9583 51.4802 43.0551 51.0298V51.0298Z"
        fill="#111111"
      />
      <path
        d="M26.9153 81.9136C26.9153 81.9136 27.2352 86.6999 29.4749 85.4435C31.7145 84.1871 28.91 81.9136 28.91 81.9136H26.9153Z"
        fill="#F4A28C"
      />
      <path
        d="M33.8239 50.9182C33.8239 50.9182 17.9607 62.3057 26.544 81.9137H28.914C28.914 81.9137 27.6698 67.7023 33.8239 60.9536C39.978 54.2048 33.8239 50.9182 33.8239 50.9182Z"
        fill="#106048"
      />
      <path
        opacity="0.2"
        d="M33.8239 50.9182C33.8239 50.9182 17.9607 62.3057 26.544 81.9137H28.914C28.914 81.9137 27.6698 67.7023 33.8239 60.9536C39.978 54.2048 33.8239 50.9182 33.8239 50.9182Z"
        fill="white"
      />
      <path d="M38.153 44.7717L39.5039 48.864L36.2965 50.9182L35.1431 43.8264L38.153 44.7717Z" fill="#F4A28C" />
      <path
        d="M34.2031 41.3774C34.3328 41.0691 34.5372 40.7988 34.7976 40.5913C35.0579 40.3839 35.3658 40.2459 35.6929 40.1903C36.0199 40.1347 36.3556 40.1631 36.6689 40.273C36.9822 40.3828 37.2631 40.5706 37.4856 40.819C38.556 41.9756 39.8556 43.8144 38.3862 44.8076C36.1465 46.3392 34.0925 43.4794 34.0925 43.4794C33.9246 42.7829 33.9631 42.0519 34.2031 41.3774Z"
        fill="#F4A28C"
      />
      <path
        d="M36.1268 42.3825C36.1268 42.3825 35.396 41.7683 35.0642 42.6418C34.7324 43.5153 36.0241 43.9421 36.4072 43.4993C36.7904 43.0566 36.1268 42.3825 36.1268 42.3825Z"
        fill="#F4A28C"
      />
      <path d="M37.8159 70.0606L22.1489 74.1379L24.9643 85.1683L40.6313 81.091L37.8159 70.0606Z" fill="#707070" />
      <path
        opacity="0.08"
        d="M30.2769 71.8146L32.7851 79.2693L32.6508 82.9428L36.2493 82.0174L37.849 75.3963L33.4882 70.969L30.2769 71.8146Z"
        fill="#111111"
      />
      <path
        d="M32.556 52.9443C33.0398 51.8613 33.7489 50.8961 34.6349 50.1143C35.5209 49.3324 36.5632 48.7523 37.691 48.4133C42.036 47.0931 50.0663 48.5369 52.5114 52.6532C55.861 58.2851 50.959 76.186 50.959 76.186L36.3401 77.3068C36.3401 77.3068 28.2742 62.6407 32.556 52.9443Z"
        fill="#106048"
      />
      <path
        d="M50.9629 76.1621L49.0393 101.574H45.9938L43.2762 81.8299L36.5454 77.3068L50.9629 76.1621Z"
        fill="#111111"
      />
      <path d="M36.5453 77.3069L32.3464 101.574H35.6091L42.6599 81.4152L36.5453 77.3069Z" fill="#111111" />
      <path
        opacity="0.08"
        d="M38.9588 48.0065C38.9588 48.0065 32.1134 70.2789 51.8871 71.7547L50.9549 76.1621L36.3399 77.3068C36.3399 77.3068 31.1812 69.1302 31.4024 57.643C31.4024 57.643 31.5249 51.9632 35.4867 49.4503C36.5291 48.7251 37.7129 48.2328 38.9588 48.0065V48.0065Z"
        fill="#111111"
      />
      <path
        d="M33.109 101.522L31.134 102.986C31.0551 103.038 30.9953 103.115 30.964 103.205C30.9327 103.295 30.9316 103.393 30.9608 103.483C30.99 103.574 31.0479 103.653 31.1256 103.707C31.2032 103.761 31.2964 103.788 31.3907 103.783H34.685C34.7992 103.783 34.9087 103.737 34.9895 103.656C35.0702 103.574 35.1156 103.464 35.1156 103.349V101.534L33.109 101.522Z"
        fill="#106048"
      />
      <path
        d="M48.6561 101.522L50.5087 102.986C50.5857 103.04 50.6432 103.118 50.6724 103.209C50.7017 103.299 50.7011 103.396 50.6708 103.486C50.6405 103.576 50.5822 103.654 50.5045 103.707C50.4268 103.761 50.334 103.788 50.2401 103.783H47.8938C47.5617 103.783 47.2432 103.65 47.0083 103.413C46.7735 103.176 46.6416 102.854 46.6416 102.519V101.534L48.6561 101.522Z"
        fill="#106048"
      />
      <path
        d="M34.286 44.3449C34.286 44.3449 35.001 45.6532 36.182 45.2463C37.3631 44.8395 36.5138 42.0235 36.5138 42.0235C36.5138 42.0235 37.9437 39.9415 37.7383 38.2942C37.7048 38.099 37.6103 37.9198 37.4688 37.7827C37.3273 37.6456 37.146 37.5577 36.9516 37.5319C36.7571 37.506 36.5596 37.5436 36.3877 37.6391C36.2159 37.7347 36.0788 37.8831 35.9964 38.0628C35.8613 38.3145 35.6634 38.5261 35.4222 38.6766C35.1811 38.827 34.9051 38.9111 34.6218 38.9204C32.6112 39.1437 30.7666 42.3506 34.286 44.3449Z"
        fill="#111111"
      />
      <path
        d="M48.4506 49.3546C48.4506 49.3546 58.0215 54.7871 61.0037 54.7871C63.986 54.7871 71.4278 49.1193 71.4278 49.1193L73.0078 52.4298C73.0078 52.4298 66.6878 62.3774 61.0393 61.6036C55.3908 60.8298 46.6494 55.856 46.6494 55.856L48.4506 49.3546Z"
        fill="#106048"
      />
      <path
        d="M71.4277 49.1313C71.4277 49.1313 72.8221 46.2316 73.2842 46.2675C73.7464 46.3034 73.5686 47.2367 73.5686 47.2367C73.5686 47.2367 75.0617 45.5495 75.4883 45.8008C75.9149 46.0521 75.9505 49.8213 72.9998 52.4418L71.4277 49.1313Z"
        fill="#F4A28C"
      />
      <path d="M128.497 16.7517H44.5994V22.0286H128.497V16.7517Z" fill="#111111" />
      <path
        d="M52.3929 20.7722C53.1499 20.7722 53.7635 20.1526 53.7635 19.3882C53.7635 18.6238 53.1499 18.0042 52.3929 18.0042C51.6359 18.0042 51.0222 18.6238 51.0222 19.3882C51.0222 20.1526 51.6359 20.7722 52.3929 20.7722Z"
        fill="white"
      />
      <path
        d="M56.4732 20.7722C57.2302 20.7722 57.8438 20.1526 57.8438 19.3882C57.8438 18.6238 57.2302 18.0042 56.4732 18.0042C55.7162 18.0042 55.1025 18.6238 55.1025 19.3882C55.1025 20.1526 55.7162 20.7722 56.4732 20.7722Z"
        fill="#106048"
      />
      <path
        d="M60.3165 20.7722C61.0734 20.7722 61.6871 20.1526 61.6871 19.3882C61.6871 18.6238 61.0734 18.0042 60.3165 18.0042C59.5595 18.0042 58.9458 18.6238 58.9458 19.3882C58.9458 20.1526 59.5595 20.7722 60.3165 20.7722Z"
        fill="#111111"
      />
      <path opacity="0.2" d="M122.304 27.5409H93.1094V30.7876H122.304V27.5409Z" fill="white" />
    </SvgIcon>
  );
};

export const InviteIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "13", height: "12", fill: "none" }}
      width="13"
      height="12"
      viewBox="0 0 13 12"
      fill="none"
    >
      <path d="M6.5 1V11" stroke="#106048" strokeWidth="2" strokeLinecap="round" />
      <path d="M11.5 6L1.5 6" stroke="#106048" strokeWidth="2" strokeLinecap="round" />
    </SvgIcon>
  );
};

export const RemoveIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "12", height: "12", fill: "none" }}
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <path d="M11 1L1 11M11 11L1 1" stroke="#CC3E3E" strokeWidth="2" strokeLinecap="round" />
    </SvgIcon>
  );
};

export const EventCreatedSuccessfully = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "172", height: "129", fill: "none" }}
      width="172"
      height="129"
      viewBox="0 0 172 129"
      fill="none"
    >
      <path
        d="M73.5254 8.14884C73.5254 8.14884 73.6433 12.9015 74.6915 15.916C74.7944 16.208 74.949 16.4749 75.1464 16.7013C75.3438 16.9277 75.5801 17.1092 75.8418 17.2354C76.1034 17.3616 76.3853 17.4299 76.6711 17.4365C76.957 17.4431 77.2412 17.3879 77.5075 17.2739C78.8907 16.6764 80.6088 15.4204 80.8259 12.8743L81.6757 8.61731C81.766 7.74203 81.6055 6.85768 81.2166 6.08654C80.8277 5.31541 80.2295 4.69558 79.5048 4.31279C76.881 2.71047 73.3207 5.2701 73.5254 8.14884Z"
        fill="#F4A28C"
      />
      <path d="M79.5354 8.65793L87.4624 21.5376L80.6643 25.8081L77.625 14.7277L79.5354 8.65793Z" fill="#F4A28C" />
      <path
        d="M78.5115 11.6046C78.5115 11.6046 78.3502 9.79179 79.5908 9.77142C80.8313 9.75105 81.0918 12.3786 79.4233 12.8335L78.5115 11.6046Z"
        fill="#F4A28C"
      />
      <path
        d="M73.7358 11.1294L72.731 13.0916C72.6728 13.2025 72.6414 13.3279 72.6397 13.4558C72.638 13.5837 72.6661 13.71 72.7214 13.8227C72.7766 13.9354 72.8571 14.0309 72.9554 14.1002C73.0536 14.1695 73.1664 14.2102 73.283 14.2186L74.9639 14.3544L73.7358 11.1294Z"
        fill="#F4A28C"
      />
      <path
        opacity="0.31"
        d="M78.1587 16.8802C78.8485 16.0813 79.308 15.0777 79.4799 13.9947C79.4799 13.9947 80.28 16.6493 79.2628 20.6891L78.1587 16.8802Z"
        fill="#CE8172"
      />
      <path
        d="M80.6772 12.8062C81.2836 12.8062 81.7751 12.2682 81.7751 11.6045C81.7751 10.9408 81.2836 10.4028 80.6772 10.4028C80.0709 10.4028 79.5793 10.9408 79.5793 11.6045C79.5793 12.2682 80.0709 12.8062 80.6772 12.8062Z"
        fill="#F4A28C"
      />
      <path
        d="M74.3564 8.80061C75.7769 9.57461 76.1242 9.39129 78.1587 9.03824C78.1587 9.03824 78.9712 20.4513 85.3785 16.7782C89.3296 14.5105 85.0684 11.6047 83.0898 6.38355C81.1111 1.16245 79.9884 -0.480601 76.8189 0.490293C75.587 0.947675 74.4727 1.72048 73.5687 2.7444C73.171 3.15611 72.8693 3.66619 72.6889 4.23186C72.5085 4.79754 72.4546 5.40232 72.5317 5.99549C72.6089 6.58867 72.8149 7.15295 73.1323 7.64103C73.4498 8.1291 73.8696 8.52674 74.3564 8.80061Z"
        fill="#111111"
      />
      <path
        d="M92.177 80.2122L89.7394 89.2422C88.8827 92.4167 88.6464 95.7531 89.0459 99.0343C89.4454 102.315 90.4717 105.468 92.058 108.286C93.6442 111.104 95.755 113.525 98.2527 115.391C100.75 117.257 103.579 118.526 106.555 119.116L126.168 123.006V116.936L111.48 110.357C110.312 109.833 109.252 109.06 108.36 108.083C107.467 107.107 106.761 105.946 106.282 104.668C105.803 103.39 105.561 102.021 105.569 100.64C105.578 99.2586 105.837 97.8931 106.331 96.6224L109.538 88.3867L92.177 80.2122Z"
        fill="#F4A28C"
      />
      <path
        d="M120.163 19.3039L145.705 32.6927C148.137 33.9697 150.206 35.9456 151.691 38.4095L163.327 57.6508L159.246 62.1047L138.386 45.2193L111.225 37.2077L120.163 19.3039Z"
        fill="#F4A28C"
      />
      <path
        d="M80.665 25.8082L87.4879 21.5376C87.4879 21.5376 100.842 7.51057 120.188 19.3039C139.534 31.0972 111.225 78.671 111.225 78.671L82.8669 74.0135C82.8669 74.0135 89.5162 58.8593 71.2308 48.5461L64.0481 40.9419C64.0481 40.9419 73.8731 30.0856 80.665 25.8082Z"
        fill="#106048"
      />
      <path
        opacity="0.08"
        d="M117.601 45.5451C117.601 45.5451 121.912 50.7595 114.171 53.4481C106.43 56.1367 97.4239 66.4431 94.5335 75.928L82.8911 74.0134C82.8911 74.0134 84.9194 69.9397 83.623 63.4082C82.3267 56.8768 103.968 44.0039 117.601 45.5451Z"
        fill="#111111"
      />
      <path
        d="M64.0476 40.9419C64.0476 40.9419 54.3404 49.7682 58.2109 59.6062C62.0813 69.4441 80.3295 67.1153 95.4888 57.678C110.648 48.2406 113.117 46.6383 113.117 46.6383L110.301 40.9487L78.9711 51.3909L64.0476 40.9419Z"
        fill="#F4A28C"
      />
      <path
        d="M110.301 40.942C110.301 40.942 118.749 39.3804 120.455 42.843C123.606 49.2251 114.171 48.7634 113.117 46.6315L110.301 40.942Z"
        fill="#111111"
      />
      <path d="M117.601 17.8713L138.82 29.0875L135.322 44.3231L123.884 40.9419L117.601 17.8713Z" fill="#106048" />
      <path d="M132.159 25.5638L129.349 42.5578L134.057 43.875L137.158 28.2049L132.159 25.5638Z" fill="#111111" />
      <path
        d="M112.007 77.734L82.6312 72.1259C73.9931 70.4746 65.1274 70.9524 56.6793 73.5245L30.9507 81.3528V88.8959L64.3271 86.0918C67.8902 85.7927 71.4727 85.9294 75.0081 86.4992L98.5782 90.3013C100.099 90.5458 101.65 90.4582 103.14 90.0436C104.63 89.6291 106.03 88.8957 107.26 87.8858C108.49 86.876 109.525 85.6096 110.306 84.1597C111.086 82.7098 111.597 81.1051 111.808 79.4381L112.007 77.734Z"
        fill="#F4A28C"
      />
      <path
        d="M75.8077 69.4238L74.9641 87.7553C74.9641 87.7553 105.859 95.9027 111.25 92.1957C116.64 88.4886 112.006 77.7612 112.006 77.7612L75.8077 69.4238Z"
        fill="#111111"
      />
      <path
        d="M30.9498 81.3529C30.9498 81.3529 20.9077 76.5527 17.0372 78.6711C13.1668 80.7894 26.5397 87.4974 26.5397 87.4974C26.5397 87.4974 27.0979 93.119 30.9498 88.8552V81.3529Z"
        fill="#106048"
      />
      <path
        d="M124.599 122.626C124.599 122.626 131.539 128.784 134.994 128.058C138.449 127.331 129.294 118.844 129.294 118.844C129.294 118.844 129.964 114.295 126.093 116.719L124.599 122.626Z"
        fill="#106048"
      />
      <path d="M30.9507 81.3528L56.6793 73.5245L57.2996 86.6825L30.9507 88.8959V81.3528Z" fill="#106048" />
      <path opacity="0.46" d="M30.9507 81.3528L56.6793 73.5245L57.2996 86.6825L30.9507 88.8959V81.3528Z" fill="white" />
      <path
        d="M73.5258 8.14883L73.6126 9.77152C73.6126 9.77152 74.5306 11.0955 78.2708 10.0159L78.1591 9.03825C78.1591 9.03825 75.4176 9.37773 73.5258 8.14883Z"
        fill="#106048"
      />
      <path
        d="M87.462 88.8959C87.462 88.8959 85.8059 105.449 93.3049 110.262L106.33 104.831C106.33 104.831 104.755 100.906 107.695 93.0578C110.635 85.2092 87.462 88.8959 87.462 88.8959Z"
        fill="#111111"
      />
      <path d="M126.093 116.699L111.48 110.357L107.969 119.394L124.599 122.626L126.093 116.699Z" fill="#106048" />
      <path
        opacity="0.46"
        d="M126.093 116.699L111.48 110.357L107.969 119.394L124.599 122.626L126.093 116.699Z"
        fill="white"
      />
      <path
        opacity="0.08"
        d="M78.9716 51.3909L72.6386 52.8371C72.6386 52.8371 70.0707 45.2804 74.9646 40.9148C79.8585 36.5491 87.6367 40.8333 90.8745 47.4123L78.9716 51.3909Z"
        fill="#111111"
      />
      <path
        opacity="0.46"
        d="M104.21 36.5424C106.29 36.5424 107.975 34.6972 107.975 32.4212C107.975 30.1451 106.29 28.3 104.21 28.3C102.131 28.3 100.445 30.1451 100.445 32.4212C100.445 34.6972 102.131 36.5424 104.21 36.5424Z"
        fill="white"
      />
      <path
        d="M159.221 62.1047C159.221 62.1047 163.265 67.8893 169.425 64.997C175.584 62.1047 163.327 57.6508 163.327 57.6508L159.221 62.1047Z"
        fill="#111111"
      />
      <path
        d="M0.452148 59.8127C0.452157 62.0028 1.0452 64.1437 2.15638 65.9652C3.26756 67.7866 4.84703 69.2068 6.6953 70.0464C8.54358 70.886 10.5778 71.1073 12.5409 70.6825C14.5041 70.2576 16.3082 69.2056 17.7253 67.6593C19.1425 66.113 20.1091 64.1418 20.5032 61.9946C20.8973 59.8475 20.7011 57.6206 19.9394 55.5954C19.1777 53.5702 17.8848 51.8374 16.2238 50.6159C14.5628 49.3944 12.6082 48.739 10.6071 48.7324C9.27522 48.7292 7.95585 49.0133 6.72442 49.5686C5.49299 50.1239 4.37368 50.9394 3.43051 51.9685C2.48734 52.9976 1.73882 54.2201 1.22776 55.5661C0.716703 56.9121 0.45314 58.3552 0.452148 59.8127Z"
        fill="white"
      />
      <path
        d="M0.452166 59.8127C0.452956 57.6184 1.04905 55.4738 2.16489 53.6507C3.28073 51.8276 4.86606 50.4082 6.71991 49.5723C8.57377 48.7364 10.6127 48.5217 12.5781 48.9554C14.5436 49.3892 16.3472 50.4518 17.7601 52.0086C19.1731 53.5654 20.1319 55.5463 20.515 57.7002C20.898 59.8541 20.6881 62.0839 19.9118 64.1071C19.1355 66.1302 17.8278 67.8556 16.1545 69.0644C14.4811 70.2732 12.5175 70.9111 10.5125 70.8971C7.83652 70.8829 5.27489 69.7081 3.38907 67.6304C1.50326 65.5526 0.447125 62.7413 0.452166 59.8127ZM16.8333 56.354C16.7325 54.9863 16.4951 53.6348 16.1255 52.3237C16.1071 52.2709 16.0722 52.2269 16.0271 52.1994C15.0582 51.5392 14.0327 50.9843 12.9651 50.5426C12.9119 50.5261 12.8556 50.5261 12.8023 50.5426L11.595 50.9568C10.7815 51.2253 10.0058 51.6156 9.28994 52.1166C9.26254 52.1278 9.23977 52.1495 9.22586 52.1777C9.21194 52.2059 9.20782 52.2386 9.21424 52.2698C9.39214 53.5498 9.56624 54.8297 9.74413 56.1055C9.74929 56.132 9.75934 56.157 9.77366 56.1791C9.78798 56.2012 9.80626 56.2198 9.8274 56.2339C11.089 56.9022 12.3431 57.5663 13.5896 58.2263C13.6357 58.247 13.6874 58.247 13.7334 58.2263L16.7614 56.441C16.7841 56.4451 16.8068 56.3913 16.8333 56.354ZM5.2098 59.5849L6.48154 59.6553C6.5281 59.658 6.57392 59.6418 6.61022 59.6097C7.56402 58.53 8.51277 57.4475 9.45648 56.3623C9.485 56.327 9.49993 56.281 9.49811 56.2339C9.32905 54.9719 9.15621 53.7085 8.97958 52.4438C8.95687 52.2616 8.95687 52.2616 8.77898 52.2367C7.83221 52.0815 6.87354 52.0316 5.91758 52.0876C5.85312 52.0917 5.7918 52.1194 5.74348 52.1663C4.8262 53.0962 3.97113 54.0971 3.18488 55.1611C3.15728 55.2016 3.14385 55.2515 3.14703 55.3019C3.2038 55.7617 3.26436 56.2173 3.32492 56.673C3.44201 57.596 3.60501 58.5114 3.81317 59.4151C3.81317 59.4772 3.83967 59.5186 3.91536 59.5228C4.34684 59.5352 4.77832 59.56 5.2098 59.5849ZM16.9165 56.6854L16.8181 56.7434L13.8583 58.4914C13.8226 58.5095 13.792 58.538 13.77 58.5738C13.748 58.6095 13.7353 58.6512 13.7334 58.6943C13.635 59.5228 13.529 60.3512 13.4269 61.1589C13.3436 61.7968 13.2641 62.4388 13.1884 63.0809C13.185 63.1092 13.1873 63.1379 13.1951 63.1651C13.203 63.1923 13.2162 63.2173 13.2338 63.2383L15.2247 65.1934C15.2422 65.2066 15.262 65.2156 15.2828 65.2199C15.3037 65.2242 15.3252 65.2236 15.3458 65.2182C16.4556 64.8168 17.5015 64.2285 18.4457 63.4744C18.5171 63.4196 18.566 63.3363 18.5819 63.2424C18.7608 62.3032 18.8872 61.3528 18.9604 60.3968C18.9692 60.3049 18.9562 60.2122 18.9226 60.1275C18.669 59.5683 18.4267 59.005 18.1656 58.4707C17.81 57.8275 17.3912 57.2288 16.9165 56.6854ZM5.11897 59.8541L3.84724 59.792C3.82453 59.7935 3.80236 59.8001 3.78215 59.8115C3.76194 59.8229 3.74414 59.8389 3.7299 59.8583C3.605 60.0695 3.48388 60.2725 3.35141 60.5003C2.99738 61.252 2.73523 62.0514 2.57172 62.8779C2.56693 62.9178 2.57354 62.9583 2.59064 62.9939C3.0147 63.9706 3.48596 64.9219 4.00242 65.8437C4.03288 65.8902 4.07492 65.9262 4.12354 65.9473C4.59286 66.0922 5.06219 66.2538 5.54288 66.3615C6.2426 66.5051 6.95486 66.562 7.66622 66.5313C7.73813 66.5313 7.74191 66.4775 7.76084 66.4277C8.01317 65.6794 8.25666 64.9297 8.49133 64.1786C8.50624 64.148 8.51404 64.1138 8.51404 64.0791C8.51404 64.0445 8.50624 64.0103 8.49133 63.9797L6.54966 60.0074C6.53763 59.9781 6.51788 59.9533 6.49293 59.9364C6.46799 59.9194 6.43898 59.911 6.40962 59.9121L5.11897 59.8541ZM10.7169 69.0829H10.7698C11.7481 68.9751 12.7174 68.7854 13.6691 68.5154C13.7125 68.5007 13.7508 68.4718 13.7789 68.4326C14.3705 67.5626 14.8082 66.5792 15.0695 65.5331C15.0805 65.4999 15.0812 65.4637 15.0716 65.4301C15.0621 65.3964 15.0427 65.3671 15.0165 65.3466C14.3756 64.7253 13.7448 64.1026 13.1241 63.4785C13.0924 63.4441 13.0529 63.4195 13.0097 63.4071C12.9665 63.3948 12.9211 63.3951 12.878 63.4081L8.9001 64.1868C8.86752 64.1899 8.8366 64.2039 8.81154 64.2268C8.78648 64.2498 8.7685 64.2807 8.76006 64.3153C8.52539 65.0443 8.29073 65.7691 8.04849 66.494C8.03153 66.5384 8.02609 66.587 8.03277 66.6345C8.03945 66.682 8.05798 66.7266 8.08634 66.7633C8.75217 67.7567 9.6396 68.5468 10.6639 69.058C10.6807 69.0682 10.6985 69.0766 10.7169 69.0829ZM1.40975 55.8942L1.54601 55.8321L2.79124 55.2149C2.85306 55.1813 2.90833 55.1349 2.954 55.0782C3.79734 53.9481 4.71038 52.8824 5.6867 51.8888C5.72426 51.8481 5.75275 51.7985 5.76997 51.7438L6.09926 50.8284L6.36799 50.0828C4.1045 51.2585 2.33358 53.3313 1.41354 55.8818L1.40975 55.8942ZM20.0694 57.083L20.0353 57.1907C19.783 58.0357 19.5382 58.8807 19.301 59.7257C19.2601 59.8331 19.2321 59.9459 19.2178 60.0612C19.1414 61.1761 18.9921 62.2835 18.7712 63.375C18.7439 63.4828 18.7312 63.5945 18.7333 63.7064C18.7825 64.1454 18.8431 64.5803 18.8998 65.0194C18.8998 65.152 18.9339 65.2887 18.9566 65.4543C19.7191 64.0981 20.195 62.5725 20.3495 60.9891C20.4855 59.6795 20.3904 58.3534 20.0694 57.083ZM9.24452 70.4788C10.4421 70.6586 11.6597 70.5954 12.8364 70.2924C14.0028 69.9942 15.1072 69.4573 16.0914 68.7101C15.4177 68.6811 14.744 68.6687 14.0741 68.6562C14.0357 68.6591 13.9977 68.666 13.9605 68.677C12.9871 68.9636 11.9951 69.1686 10.9932 69.29C10.8405 69.29 10.6914 69.3405 10.5655 69.435C10.1643 69.7663 9.7517 70.077 9.34293 70.3959L9.24452 70.4788ZM4.17652 67.9935C4.17652 67.9438 4.17652 67.9231 4.17652 67.9065C4.1084 67.4094 4.04405 66.9165 3.97592 66.4236C3.96717 66.3013 3.93765 66.1819 3.88887 66.0715C3.33621 65.0762 2.83088 64.0504 2.3749 62.998C2.35253 62.9491 2.32314 62.9043 2.28785 62.8655L0.940421 61.5897L0.872292 61.54C1.0726 62.9067 1.5135 64.2178 2.17052 65.4005C2.70987 66.3729 3.38552 67.2465 4.17274 67.9894L4.17652 67.9935ZM11.6858 49.1135L11.7388 49.1756C12.0908 49.5194 12.439 49.8674 12.791 50.207C12.8257 50.2394 12.8654 50.2647 12.9083 50.2816C14.0562 50.7451 15.1592 51.332 16.2012 52.0337C16.2773 52.0806 16.3607 52.1115 16.4472 52.1249C16.6175 52.1497 16.7916 52.1663 16.9658 52.1828L17.5373 52.2408C15.9739 50.4922 13.9071 49.3876 11.6858 49.1135Z"
        fill="#111111"
      />
      <path
        d="M16.8334 56.354C16.8069 56.3913 16.7842 56.4451 16.7464 56.4658L13.7184 58.2511C13.6724 58.2718 13.6207 58.2718 13.5746 58.2511C12.313 57.5939 11.0589 56.9298 9.81241 56.2587C9.79127 56.2447 9.77298 56.226 9.75866 56.2039C9.74434 56.1819 9.7343 56.1568 9.72914 56.1303C9.55125 54.8545 9.37714 53.5746 9.19925 52.2947C9.19282 52.2634 9.19694 52.2307 9.21086 52.2025C9.22478 52.1744 9.24754 52.1527 9.27495 52.1414C9.99081 51.6405 10.7665 51.2502 11.58 50.9816L12.7873 50.5674C12.8406 50.5509 12.8969 50.5509 12.9501 50.5674C14.0177 51.0092 15.0432 51.5641 16.0121 52.2243C16.0572 52.2517 16.0921 52.2957 16.1105 52.3485C16.4837 53.651 16.7261 54.9941 16.8334 56.354Z"
        fill="white"
      />
      <path
        d="M5.20996 59.5849C4.77848 59.5601 4.347 59.5352 3.91552 59.5187C3.83982 59.5187 3.82847 59.4731 3.81333 59.411C3.60517 58.5073 3.44217 57.5919 3.32508 56.6689C3.26452 56.2132 3.20396 55.7576 3.14719 55.2978C3.14401 55.2474 3.15744 55.1975 3.18503 55.157C3.97129 54.093 4.82636 53.0921 5.74364 52.1622C5.79196 52.1153 5.85328 52.0876 5.91774 52.0835C6.8737 52.0275 7.83237 52.0774 8.77914 52.2326C8.95703 52.2575 8.95703 52.2575 8.97974 52.4397C9.15385 53.7045 9.32669 54.9678 9.49827 56.2298C9.50009 56.2769 9.48517 56.3229 9.45664 56.3582C8.51041 57.4434 7.56166 58.5259 6.61038 59.6056C6.57408 59.6377 6.52826 59.6539 6.4817 59.6512L5.20996 59.5808V59.5849Z"
        fill="white"
      />
      <path
        d="M16.916 56.6854C17.3901 57.2263 17.809 57.8221 18.165 58.4624C18.4413 59.005 18.6835 59.5684 18.922 60.1193C18.9556 60.2039 18.9687 60.2967 18.9598 60.3885C18.8866 61.3446 18.7602 62.2949 18.5813 63.2342C18.5654 63.3281 18.5165 63.4113 18.4451 63.4662C17.5009 64.2202 16.455 64.8086 15.3452 65.21C15.3246 65.2154 15.3031 65.216 15.2823 65.2117C15.2614 65.2074 15.2416 65.1984 15.2241 65.1851L13.2332 63.23C13.2156 63.2091 13.2024 63.1841 13.1945 63.1569C13.1867 63.1297 13.1844 63.1009 13.1878 63.0727C13.2635 62.4306 13.343 61.7886 13.4263 61.1507C13.5285 60.3222 13.6344 59.4938 13.7329 58.6861C13.7347 58.643 13.7474 58.6013 13.7694 58.5655C13.7914 58.5297 13.822 58.5012 13.8578 58.4831L16.8176 56.7351L16.916 56.6854Z"
        fill="white"
      />
      <path
        d="M5.11944 59.8541L6.41389 59.9246C6.44324 59.9234 6.47225 59.9318 6.49719 59.9488C6.52214 59.9658 6.5419 59.9905 6.55393 60.0198L8.49559 63.9922C8.5105 64.0228 8.5183 64.0569 8.5183 64.0916C8.5183 64.1263 8.5105 64.1604 8.49559 64.191C8.24326 64.9421 7.99977 65.6918 7.7651 66.4402C7.7651 66.4899 7.74239 66.5438 7.67048 66.5438C6.95912 66.5745 6.24686 66.5175 5.54714 66.3739C5.06645 66.2538 4.59713 66.0923 4.1278 65.9597C4.07918 65.9386 4.03714 65.9027 4.00668 65.8562C3.49022 64.9343 3.01896 63.983 2.59491 63.0063C2.5778 62.9708 2.57119 62.9302 2.57598 62.8904C2.73949 62.0638 3.00163 61.2644 3.35567 60.5128C3.46922 60.2932 3.59034 60.0985 3.73416 59.8707C3.7484 59.8513 3.7662 59.8354 3.78641 59.824C3.80662 59.8126 3.82879 59.8059 3.8515 59.8044L5.12323 59.8666L5.11944 59.8541Z"
        fill="white"
      />
      <path
        d="M10.7167 69.0829C10.6931 69.0778 10.6702 69.0694 10.6485 69.058C9.62425 68.5468 8.73683 67.7567 8.071 66.7633C8.04264 66.7266 8.0241 66.682 8.01742 66.6345C8.01074 66.587 8.01618 66.5384 8.03314 66.494C8.27538 65.7692 8.51005 65.0443 8.74471 64.3153C8.75315 64.2807 8.77113 64.2498 8.79619 64.2269C8.82125 64.2039 8.85218 64.1899 8.88475 64.1869L12.8778 63.4081C12.9209 63.3951 12.9663 63.3948 13.0095 63.4072C13.0527 63.4195 13.0921 63.4442 13.1239 63.4786C13.7572 64.1026 14.388 64.7253 15.0163 65.3467C15.0425 65.3672 15.0619 65.3965 15.0714 65.4301C15.081 65.4638 15.0803 65.4999 15.0693 65.5331C14.808 66.5792 14.3703 67.5626 13.7786 68.4326C13.7506 68.4718 13.7123 68.5007 13.6689 68.5154C12.7172 68.7854 11.7479 68.9752 10.7696 69.0829H10.7167Z"
        fill="white"
      />
      <path
        d="M1.40967 55.8942C2.32972 53.3437 4.10063 51.2709 6.36412 50.0952L6.09539 50.8408L5.76611 51.7562C5.74888 51.8108 5.72039 51.8605 5.68284 51.9011C4.70781 52.895 3.79604 53.9606 2.95391 55.0906C2.90825 55.1473 2.85298 55.1937 2.79116 55.2273L1.54593 55.8445L1.40967 55.8942Z"
        fill="white"
      />
      <path
        d="M20.0697 57.0831C20.3893 58.3495 20.4843 59.6712 20.3498 60.9767C20.1953 62.5601 19.7194 64.0857 18.9569 65.442C18.9342 65.2763 18.9153 65.1396 18.9002 65.0071C18.8434 64.568 18.7828 64.1331 18.7336 63.694C18.7315 63.5821 18.7443 63.4705 18.7715 63.3626C18.9924 62.2711 19.1417 61.1637 19.2181 60.0489C19.2324 59.9336 19.2604 59.8208 19.3014 59.7134C19.5537 58.8684 19.7984 58.0234 20.0356 57.1784L20.0697 57.0831Z"
        fill="white"
      />
      <path
        d="M9.24438 70.4789L9.34279 70.396C9.75156 70.0771 10.1641 69.7664 10.5653 69.4351C10.6913 69.3406 10.8404 69.2901 10.993 69.2901C11.995 69.1687 12.987 68.9637 13.9604 68.6771C13.9975 68.6662 14.0356 68.6592 14.0739 68.6563C14.7439 68.6563 15.4176 68.6812 16.0913 68.7102C15.1071 69.4574 14.0027 69.9943 12.8363 70.2925C11.6596 70.5955 10.442 70.6587 9.24438 70.4789Z"
        fill="white"
      />
      <path
        d="M4.17276 67.9894C3.3812 67.2463 2.70166 66.3712 2.15919 65.3964C1.50396 64.2146 1.06436 62.905 0.864746 61.5401L0.932875 61.5898L2.2803 62.8614C2.31559 62.9002 2.34498 62.945 2.36736 62.994C2.82333 64.0463 3.32866 65.0722 3.88132 66.0674C3.9301 66.1779 3.95962 66.2973 3.96838 66.4195C4.0365 66.9124 4.10085 67.4054 4.16898 67.9024C4.17276 67.919 4.17276 67.9397 4.17276 67.9894Z"
        fill="white"
      />
      <path
        d="M11.6853 49.1135C13.9066 49.3876 15.9734 50.4922 17.5368 52.2408L16.9653 52.1829C16.7912 52.1829 16.617 52.1497 16.4467 52.1249C16.3602 52.1115 16.2768 52.0806 16.2007 52.0337C15.1587 51.332 14.0557 50.7451 12.9078 50.2816C12.8649 50.2647 12.8252 50.2394 12.7905 50.2071C12.4385 49.8674 12.0903 49.5195 11.7383 49.1757L11.6853 49.1135Z"
        fill="white"
      />
    </SvgIcon>
  );
};

export const CreateEventIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "12", height: "12", fill: "none" }}
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <path d="M6 1V11" stroke="white" strokeWidth="2" strokeLinecap="round" />
      <path d="M11 6L1 6" stroke="white" strokeWidth="2" strokeLinecap="round" />
    </SvgIcon>
  );
};

export const EventDetailsLocationIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "18", height: "19", fill: "none" }}
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
    >
      <path
        d="M8.99961 2.5625C6.23211 2.5625 3.97461 4.82 3.97461 7.5875C3.97461 11.0225 8.47461 16.0775 8.66211 16.2875C8.84211 16.49 9.1571 16.49 9.3371 16.2875C9.5321 16.0775 14.0246 11.0225 14.0246 7.5875C14.0246 4.82 11.7671 2.5625 8.99961 2.5625Z"
        stroke="#414141"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.28891 9.33892C10.2584 9.1846 10.9193 8.27355 10.7649 7.30403C10.6106 6.33452 9.69958 5.67368 8.73006 5.828C7.76055 5.98232 7.09971 6.89336 7.25403 7.86288C7.40835 8.83239 8.3194 9.49324 9.28891 9.33892Z"
        stroke="#414141"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const EventDetailsDurationIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "14", height: "14", fill: "none" }}
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        d="M2.25 2.5H11.75C12.4404 2.5 13 3.05964 13 3.75V11.75C13 12.4404 12.4404 13 11.75 13H2.25C1.55964 13 1 12.4404 1 11.75V3.75C1 3.05964 1.55964 2.5 2.25 2.5Z"
        stroke="#414141"
        strokeWidth="1.5"
      />
      <path d="M1 6.25H13" stroke="#414141" strokeWidth="1.5" />
      <path
        d="M10.75 1C10.75 0.585786 10.4142 0.25 10 0.25C9.58579 0.25 9.25 0.585786 9.25 1H10.75ZM10.75 2.5V1H9.25V2.5H10.75Z"
        fill="#414141"
      />
      <path
        d="M4.75 1C4.75 0.585786 4.41421 0.25 4 0.25C3.58579 0.25 3.25 0.585786 3.25 1H4.75ZM4.75 2.5V1H3.25V2.5H4.75Z"
        fill="#414141"
      />
    </SvgIcon>
  );
};

export const EventDetailsDateIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "14", height: "15", fill: "none" }}
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
    >
      <path
        d="M2.25 3H11.75C12.4404 3 13 3.55964 13 4.25V12.25C13 12.9404 12.4404 13.5 11.75 13.5H2.25C1.55964 13.5 1 12.9404 1 12.25V4.25C1 3.55964 1.55964 3 2.25 3Z"
        stroke="#414141"
        strokeWidth="1.5"
      />
      <path d="M1 6.75H13" stroke="#414141" strokeWidth="1.5" />
      <path
        d="M10.75 1.5C10.75 1.08579 10.4142 0.75 10 0.75C9.58579 0.75 9.25 1.08579 9.25 1.5H10.75ZM10.75 3V1.5H9.25V3H10.75Z"
        fill="#414141"
      />
      <path
        d="M4.75 1.5C4.75 1.08579 4.41421 0.75 4 0.75C3.58579 0.75 3.25 1.08579 3.25 1.5H4.75ZM4.75 3V1.5H3.25V3H4.75Z"
        fill="#414141"
      />
    </SvgIcon>
  );
};

export const CalendarLeftIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "18", height: "18", fill: "none" }}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M11.25 4.5L6.75 9L11.25 13.5"
        stroke="#106048"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const CalendarRightIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "18", height: "18", fill: "none" }}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M6.75 4.5L11.25 9L6.75 13.5"
        stroke="#106048"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const EventDetailsDescriptionIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "18", height: "18", fill: "none" }}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M10.5 8.25H6M7.5 11.25H6M12 5.25H6M15 5.1V12.9C15 14.1601 15 14.7902 14.7548 15.2715C14.539 15.6948 14.1948 16.039 13.7715 16.2548C13.2902 16.5 12.6601 16.5 11.4 16.5H6.6C5.33988 16.5 4.70982 16.5 4.22852 16.2548C3.80516 16.039 3.46095 15.6948 3.24524 15.2715C3 14.7902 3 14.1601 3 12.9V5.1C3 3.83988 3 3.20982 3.24524 2.72852C3.46095 2.30516 3.80516 1.96095 4.22852 1.74524C4.70982 1.5 5.33988 1.5 6.6 1.5H11.4C12.6601 1.5 13.2902 1.5 13.7715 1.74524C14.1948 1.96095 14.539 2.30516 14.7548 2.72852C15 3.20982 15 3.83988 15 5.1Z"
        stroke="#414141"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const EventDurationIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "13.5", height: "12.75", fill: "none" }}
      width="13.5"
      height="12.75"
      viewBox="0 0 13.5 12.75"
      fill="none"
    >
      <path
        d="M2.25 2.5H11.75C12.4404 2.5 13 3.05964 13 3.75V11.75C13 12.4404 12.4404 13 11.75 13H2.25C1.55964 13 1 12.4404 1 11.75V3.75C1 3.05964 1.55964 2.5 2.25 2.5Z"
        stroke="#414141"
        strokeWidth="1.5"
      />
      <path d="M1 6.25H13" stroke="#414141" strokeWidth="1.5" />
      <path
        d="M10.75 1C10.75 0.585786 10.4142 0.25 10 0.25C9.58579 0.25 9.25 0.585786 9.25 1H10.75ZM10.75 2.5V1H9.25V2.5H10.75Z"
        fill="#414141"
      />
      <path
        d="M4.75 1C4.75 0.585786 4.41421 0.25 4 0.25C3.58579 0.25 3.25 0.585786 3.25 1H4.75ZM4.75 2.5V1H3.25V2.5H4.75Z"
        fill="#414141"
      />
    </SvgIcon>
  );
};

export const EventTypeIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "18", height: "18", fill: "none" }}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M12 5.25C12 4.55252 12 4.20378 11.9233 3.91766C11.7153 3.1412 11.1088 2.53472 10.3323 2.32667C10.0462 2.25 9.69748 2.25 9 2.25C8.30252 2.25 7.95378 2.25 7.66766 2.32667C6.8912 2.53472 6.28472 3.1412 6.07667 3.91766C6 4.20378 6 4.55252 6 5.25M9.6 13.125H13.275C13.485 13.125 13.59 13.125 13.6702 13.0841C13.7408 13.0482 13.7982 12.9908 13.8341 12.9202C13.875 12.84 13.875 12.735 13.875 12.525V10.725C13.875 10.515 13.875 10.41 13.8341 10.3298C13.7982 10.2592 13.7408 10.2018 13.6702 10.1659C13.59 10.125 13.485 10.125 13.275 10.125H9.6C9.38998 10.125 9.28497 10.125 9.20475 10.1659C9.13419 10.2018 9.07683 10.2592 9.04087 10.3298C9 10.41 9 10.515 9 10.725V12.525C9 12.735 9 12.84 9.04087 12.9202C9.07683 12.9908 9.13419 13.0482 9.20475 13.0841C9.28497 13.125 9.38998 13.125 9.6 13.125ZM5.1 15.75H12.9C14.1601 15.75 14.7902 15.75 15.2715 15.5048C15.6948 15.289 16.039 14.9448 16.2548 14.5215C16.5 14.0402 16.5 13.4101 16.5 12.15V8.85C16.5 7.58988 16.5 6.95982 16.2548 6.47852C16.039 6.05516 15.6948 5.71095 15.2715 5.49524C14.7902 5.25 14.1601 5.25 12.9 5.25H5.1C3.83988 5.25 3.20982 5.25 2.72852 5.49524C2.30516 5.71095 1.96095 6.05516 1.74524 6.47852C1.5 6.95982 1.5 7.58988 1.5 8.85V12.15C1.5 13.4101 1.5 14.0402 1.74524 14.5215C1.96095 14.9448 2.30516 15.289 2.72852 15.5048C3.20982 15.75 3.83988 15.75 5.1 15.75Z"
        stroke="#414141"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const EventPrivacyIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "18", height: "18", fill: "none" }}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <g clipPath="url(#clip0_25820_35732)">
        <path
          d="M9 1.5C10.876 3.55376 11.9421 6.21903 12 9C11.9421 11.781 10.876 14.4462 9 16.5M9 1.5C7.12404 3.55376 6.05794 6.21903 6 9C6.05794 11.781 7.12404 14.4462 9 16.5M9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5M9 1.5C13.1421 1.5 16.5 4.85786 16.5 9C16.5 13.1421 13.1421 16.5 9 16.5M1.87501 6.75H16.125M1.875 11.25H16.125"
          stroke="#414141"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_25820_35732">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export const EventPlayerInviteIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "12", height: "12", fill: "none" }}
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <path d="M6 1V11" stroke="#106048" strokeWidth="2" strokeLinecap="round" />
      <path d="M11 6L1 6" stroke="#106048" strokeWidth="2" strokeLinecap="round" />
    </SvgIcon>
  );
};

export const FindPlayersIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "240", height: "180", fill: "none" }}
      width="240"
      height="180"
      viewBox="0 0 240 180"
      fill="none"
    >
      <path
        d="M105.864 54.093C105.864 54.093 87.3238 40.4442 68.7898 42.3011C50.2558 44.1579 31.5298 67.9388 31.5298 67.9388L37.5298 72.4645C37.5298 72.4645 68.6278 46.791 85.4698 65.7715C102.312 84.752 105.864 54.093 105.864 54.093Z"
        fill="#106048"
      />
      <path
        opacity="0.2"
        d="M105.864 54.093C105.864 54.093 87.3238 40.4442 68.7898 42.3011C50.2558 44.1579 31.5298 67.9388 31.5298 67.9388L37.5298 72.4645C37.5298 72.4645 68.6278 46.791 85.4698 65.7715C102.312 84.752 105.864 54.093 105.864 54.093Z"
        fill="white"
      />
      <path d="M91.8602 52.1885H28.2002V93.1169H91.8602V52.1885Z" fill="#A0A0A0" />
      <path
        opacity="0.45"
        d="M194.892 139.586C193.719 139.35 192.614 138.857 191.656 138.144C190.698 137.43 189.912 136.513 189.354 135.46V135.4L160.944 81.5635L145.308 92.5792L156.366 127.173C156.658 128.082 156.724 129.049 156.558 129.989C156.393 130.929 156.002 131.816 155.418 132.573C154.834 133.331 154.074 133.936 153.204 134.338C152.333 134.74 151.378 134.926 150.42 134.881C142.02 134.499 133.086 134.284 123.804 134.284C75.852 134.284 36.978 139.842 36.978 146.703C36.978 153.563 75.852 159.127 123.804 159.127C171.756 159.127 210.6 153.569 210.6 146.721C210.6 144.058 204.786 141.604 194.892 139.586Z"
        fill="#CFCFCF"
      />
      <path
        d="M104.544 142.648C104.544 142.648 105.432 145.634 108.066 145.986C110.7 146.338 111.252 148.971 108.834 149.509C106.416 150.046 100.434 146.673 100.434 146.673L100.812 142.881L104.544 142.648Z"
        fill="#106048"
      />
      <path
        d="M53.2619 142.141C53.2619 142.141 50.2139 142.798 49.6619 145.383C49.1099 147.968 46.4339 148.315 46.0619 145.873C45.6899 143.431 49.5479 137.765 49.5479 137.765L53.3159 138.439L53.2619 142.141Z"
        fill="#106048"
      />
      <path
        d="M53.6701 97.5649C53.6701 97.5649 50.8621 110.605 60.9721 116.193C71.0821 121.782 102.972 111.721 98.0461 143.395H105.162C105.162 143.395 114.36 117.125 90.4981 107.787L83.2561 99.6129L53.6701 97.5649Z"
        fill="#111111"
      />
      <path d="M151.845 88.1523L149.424 85.8506L134.286 101.615L136.706 103.916L151.845 88.1523Z" fill="#A0A0A0" />
      <path
        opacity="0.08"
        d="M151.845 88.1523L149.424 85.8506L134.286 101.615L136.706 103.916L151.845 88.1523Z"
        fill="#111111"
      />
      <path d="M150.666 87.0239L148.245 84.7222L133.107 100.486L135.527 102.788L150.666 87.0239Z" fill="#A0A0A0" />
      <path
        d="M157.249 89.9245C161.141 85.8718 162.094 80.4922 159.377 77.9087C156.661 75.3253 151.303 76.5164 147.411 80.5691C143.519 84.6218 142.567 90.0015 145.283 92.5849C148 95.1684 153.357 93.9773 157.249 89.9245Z"
        fill="#A0A0A0"
      />
      <path
        opacity="0.08"
        d="M157.249 89.9245C161.141 85.8718 162.094 80.4922 159.377 77.9087C156.661 75.3253 151.303 76.5164 147.411 80.5691C143.519 84.6218 142.567 90.0015 145.283 92.5849C148 95.1684 153.357 93.9773 157.249 89.9245Z"
        fill="#111111"
      />
      <path
        d="M156.067 88.8054C159.959 84.7527 160.912 79.373 158.195 76.7896C155.478 74.2061 150.121 75.3972 146.229 79.45C142.337 83.5027 141.384 88.8824 144.101 91.4658C146.818 94.0492 152.175 92.8581 156.067 88.8054Z"
        fill="#A0A0A0"
      />
      <path
        opacity="0.57"
        d="M154.397 87.2175C156.968 84.5403 157.598 80.9867 155.804 79.2804C154.009 77.574 150.47 78.3611 147.899 81.0383C145.328 83.7155 144.699 87.269 146.493 88.9753C148.288 90.6817 151.826 89.8947 154.397 87.2175Z"
        fill="white"
      />
      <path
        d="M130.95 55.5676C130.95 55.5676 128.244 59.4784 125.616 61.4009C125.361 61.5856 125.072 61.7186 124.766 61.7922C124.459 61.8658 124.141 61.8786 123.83 61.8298C123.518 61.781 123.22 61.6716 122.951 61.5078C122.682 61.3441 122.448 61.1292 122.262 60.8755C121.308 59.544 120.408 57.4663 121.602 55.1975L123.15 51.0957C123.551 50.3117 124.187 49.6705 124.969 49.26C125.751 48.8495 126.641 48.6899 127.518 48.803C130.8 48.994 132.714 53.269 130.95 55.5676Z"
        fill="#F4A28C"
      />
      <path d="M124.098 51.9375L111.888 56.8334L113.388 65.4788L122.19 58.332L124.098 51.9375Z" fill="#F4A28C" />
      <path
        d="M129.912 54.9704C128.738 54.0804 127.671 53.0586 126.732 51.9254C126.647 52.6929 126.339 53.4191 125.846 54.0151C125.352 54.6111 124.695 55.0509 123.954 55.2808C123.24 55.5148 122.467 55.4944 121.766 55.2232C121.066 54.9519 120.482 54.4468 120.114 53.7942L124.074 49.1371C124.615 48.4479 125.334 47.9175 126.154 47.6021C126.974 47.2868 127.864 47.1982 128.73 47.3459C129.479 47.4742 130.218 47.6497 130.944 47.8713C132.744 48.4684 133.998 50.988 135.978 51.0716C136.177 51.0813 136.371 51.1422 136.539 51.2484C136.707 51.3547 136.845 51.5025 136.939 51.6776C137.033 51.8527 137.079 52.049 137.074 52.2473C137.068 52.4456 137.011 52.6392 136.908 52.809C135.936 54.4151 133.812 56.457 131.214 55.6391C130.746 55.4889 130.306 55.263 129.912 54.9704Z"
        fill="#111111"
      />
      <path
        d="M124.44 55.4962C124.44 55.4962 125.58 54.0632 124.44 53.293C123.3 52.5228 121.626 54.5886 122.916 55.9678L124.44 55.4962Z"
        fill="#F4A28C"
      />
      <path
        d="M129.12 57.9438L128.976 60.1948C128.964 60.3207 128.92 60.4418 128.85 60.5469C128.779 60.6521 128.683 60.7382 128.57 60.7974C128.458 60.8565 128.333 60.887 128.205 60.8861C128.078 60.8851 127.953 60.8527 127.842 60.7918L126.216 59.8962L129.12 57.9438Z"
        fill="#F4A28C"
      />
      <path
        opacity="0.31"
        d="M121.2 59.126C121.2 59.126 121.566 56.4094 122.55 55.3765C122.55 55.3765 118.104 56.8691 118.002 61.7351L121.2 59.126Z"
        fill="#CE8172"
      />
      <path
        opacity="0.08"
        d="M40.5962 92.0598C40.5962 92.0598 40.4042 63.8965 74.4002 57.9438L54.4262 93.1166H40.6262L40.5962 92.0598Z"
        fill="#111111"
      />
      <path
        d="M115.008 68.47L114 62.6367C113.606 60.2577 112.611 58.0172 111.11 56.125C109.608 54.2329 107.648 52.7509 105.414 51.818C103.469 51.0443 101.436 50.5129 99.3599 50.2358C96.6959 49.8656 92.9639 50.2358 88.7879 51.3284C70.7999 56.0272 57.5999 71.1925 54.8699 89.4745L53.6699 97.5646L83.2559 99.6125C83.2559 99.6125 81.7559 91.2537 92.2559 91.2537C102.756 91.2537 116.052 91.3612 115.008 68.47Z"
        fill="#106048"
      />
      <path
        opacity="0.08"
        d="M86.0159 59.4248C86.0159 59.4248 71.6579 61.9384 55.8779 84.5669L53.6699 97.5649L76.1219 99.2247L86.0159 59.4248Z"
        fill="#111111"
      />
      <path
        d="M102.48 69.8314C105.282 60.5292 94.4162 53.0063 86.6702 58.9172C80.1902 63.8548 72.8702 72.745 72.5822 87.7491C72.0842 114.826 98.1482 109.984 133.422 99.6127L132.3 91.7255C132.3 91.7255 90.0602 99.6724 95.7962 86.0117C98.1962 80.2978 100.992 74.781 102.48 69.8314Z"
        fill="#106048"
      />
      <path
        opacity="0.2"
        d="M102.48 69.8314C105.282 60.5292 94.4162 53.0063 86.6702 58.9172C80.1902 63.8548 72.8702 72.745 72.5822 87.7491C72.0842 114.826 98.1482 109.984 133.422 99.6127L132.3 91.7255C132.3 91.7255 90.0602 99.6724 95.7962 86.0117C98.1962 80.2978 100.992 74.781 102.48 69.8314Z"
        fill="white"
      />
      <path
        d="M87.6541 107.852C87.6541 107.852 88.5241 137.795 53.3161 143.395L51.9541 137.048C51.9541 137.048 80.1541 130.092 61.9381 111.458L87.6541 107.852Z"
        fill="#111111"
      />
      <path
        opacity="0.08"
        d="M143.112 148.118C145.226 148.118 146.94 147.487 146.94 146.709C146.94 145.931 145.226 145.3 143.112 145.3C140.998 145.3 139.284 145.931 139.284 146.709C139.284 147.487 140.998 148.118 143.112 148.118Z"
        fill="#111111"
      />
      <path
        opacity="0.08"
        d="M157.752 144.469C159.866 144.469 161.58 143.839 161.58 143.06C161.58 142.282 159.866 141.651 157.752 141.651C155.638 141.651 153.924 142.282 153.924 143.06C153.924 143.839 155.638 144.469 157.752 144.469Z"
        fill="#111111"
      />
      <path
        opacity="0.08"
        d="M172.494 147.288C174.608 147.288 176.322 146.657 176.322 145.879C176.322 145.101 174.608 144.47 172.494 144.47C170.38 144.47 168.666 145.101 168.666 145.879C168.666 146.657 170.38 147.288 172.494 147.288Z"
        fill="#111111"
      />
      <path
        opacity="0.08"
        d="M195.066 148.703C197.18 148.703 198.894 148.072 198.894 147.294C198.894 146.516 197.18 145.885 195.066 145.885C192.952 145.885 191.238 146.516 191.238 147.294C191.238 148.072 192.952 148.703 195.066 148.703Z"
        fill="#111111"
      />
      <path
        opacity="0.08"
        d="M128.598 144.153C130.759 144.153 132.51 143.507 132.51 142.709C132.51 141.911 130.759 141.264 128.598 141.264C126.437 141.264 124.686 141.911 124.686 142.709C124.686 143.507 126.437 144.153 128.598 144.153Z"
        fill="#111111"
      />
      <path
        d="M132.516 93.2421C132.516 93.2421 142.224 92.2211 143.076 95.9945C143.928 99.7679 142.068 101.768 133.332 98.9798L132.516 93.2421Z"
        fill="#F4A28C"
      />
      <path
        d="M35.8018 93.1168C35.8018 93.1168 37.1998 98.753 42.7978 97.5648C48.3958 96.3767 44.3998 89.4628 35.8018 93.1168Z"
        fill="#F4A28C"
      />
    </SvgIcon>
  );
};

export const DeletePlayerIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "13", height: "12", fill: "none" }}
      width="13"
      height="12"
      viewBox="0 0 13 12"
      fill="none"
    >
      <path d="M11.6182 1L1.61816 11M11.6182 11L1.61816 1" stroke="#CC3E3E" strokeWidth="2" strokeLinecap="round" />
    </SvgIcon>
  );
};

export const AcceptPlayerIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "18", height: "13", fill: "none" }}
      width="18"
      height="13"
      viewBox="0 0 18 13"
      fill="none"
    >
      <path d="M17 1L6 12L1 7" stroke="#106048" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </SvgIcon>
  );
};

export const CloseDialogButtonIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "24", height: "24", fill: "none" }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path d="M17 7L7 17M7 7L17 17" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </SvgIcon>
  );
};
